(function () {

	// inject ui.bootstrap
	angular.module("SUGApp").requires.push('ui.bootstrap');

	/** local directives that are only used here, but can certainly be used elsewhere if needed **/
	SUGApp.directive('compile',['$compile','$timeout',function(c, t){
		return{
			restrict:'A',
			link: function(scope,elem,attrs){
				t(function(){
					c(elem.contents())(scope);
				});
			}
		};
	}])
	.directive('socialShare', [function(){
		return {
			restrict: 'EA',
			scope:{
				"type" : "=",
				"destination" : "=",
				"class" : "=",
				"action" : "&onClick"
			},
			replace: true,
			templateUrl: "/view/templates/socialshare.html",
			link: function(scope, element, attrs){
				// not being used yet
			},
			controller: function(){
				// not being used yet
			}
		};
	}])
	.directive('icsDownloadIcons', [function(){
		return {
			restrict: 'EA',
			scope:{
				"text" 		: "=",
				"type" 		: "=",
				"destination" : "=",
				"class" 	: "=",
				"height" 	: "=",
				"border" 	: "=",
				"action" 	: "&onClick"
			},
			templateUrl: "/view/templates/icsdownloadicons.html",
			replace: true,
			link: function(scope, element, attrs){
				// not being used yet
			},
			controller: function(){
				// not being used yet
			}
		};
	}])
	.directive('iframeOnload', [function(){
		return {
			restrict: 'EA',
			scope:{
				callBack : '&iframeOnload'
			},
			link: function(scope, element, attrs){
				element.on('load', function(){
					scope.callBack();
					scope.$apply();
				});
			}
		};
	}])
	.controller('signUpFormController',
			['$scope','loginfactory','SUGUtilities','$sce','$timeout','signUpFormService','$uibModal','$window','authenticationService','$filter','$location','$timeout','$filter','adService','$rootScope','$q','signupPageService','$route','globalJSService','globalService', 'sortableService',
			function(s, loginfactory, util,sce,$timeout,svc,modal,win,authSvc,filter,location,timeout,$filter,adService,$rootScope,$q,signupPageService,$route,globalJSService,globalService, sortableService){

		util.showLoading( 'processing' );
		// initialize a modal
		s.loginModal = loginfactory.getLogin(true, false);	// allow registration, show login by default (showregistration=false)
		s.initialized = false;
		s.signupLoaded = false;
		s.urlkey = signupPageService.getUrlKey();
		s.h = new Date().getTime();
		s.user = {};
		s.user.loggedin = false;
		s.attrs = {};
		s.signup = {};
		s.theme = {};
		s.asyncSuccess = true;
		s.success = true;
		s.errorMessages = {};
		s.signupTitle = '';
		s.formMainTitle = 'Sign Me Up';
		s.signupDesc = '';
		s.datedisplay = "";
		s.dateformat = "";
		s.shortZone = "";
		s.tbodyColCt = 4;
		s.nodatesignup = false;
		s.arrpaytypes = ['fixed','options','noset'];
		s.hasPayItems = false;
		s.paymentRequired = false;
		s.hasPaid = false;
		s.hasPaidStatus = ['paid','cash','check','other'];
		s.paymentIsPending = false;
		s.closeLock = false;
		s.modifyLock = 0;
		s.commentsRequired = false;
		s.emailrequired = false;
		s.qtyLimitEnabled = false;
		s.socialshare = false;
		s.signupQtyLimit = 0;
		s.itemQtyLimit = 0;
		s.customFields = [];
		s.cq_address = [];
		s.cq_phone = [];
		s.complete = false;
		s.totalPrice = 0;
		s.currency_symbol = '$';
		s.currency_code = 'USD';
		s.isrsvp = false;
		s.rsvpdetails = {};
		s.rsvpheader = '';
		s.editmode = false;
		s.showsegments = true;
		s.thankYouTemplate = '/view/templates/signups/form/thankyou.html';
		s.isProcessing = false;
		s.anonymous = false;
		s.showreturntosulink = false;
		s.rsvpitemsavailable = false;
		s.editLocked = false;
		s.disableState = false;
		s.rItemQtyLookup = {};
		s.winorigin = angular.isDefined( win.location.origin ) ? win.location.origin : win.location.protocol + '//' + win.location.host;
		s.hAdWidth = 0;
		s.containerWidth = win.innerWidth;
		s.selectedState = '';
		s.selectedCountry = '';
		s.states = [];
		s.filteredStates = [];
		s.signupiswepay = false;
		s.wpfeepayer = 'payer_from_app';	// wepay fee payer default
		s.signupislumapay = false;
		s.lpfeepayer = 'payer_from_app';	// lumapay fee payer default
		s.fbAppId = '';
		s.backtosignupLink = "";
		s.showTPCookie = true;
		s.wpiframesrc = '';
		s.disablesignup = false;
		s.showproductimage = false;
		s.usenewaddirective = false;
		s.adconfig = {
			network  : '',
			platform : 'desktop',
			category : 'signups',
			section  : 'form',
			type	 : '',
			position : '',
			theme    : '',
			themeid  : 0
		};




		/** form object **/
		s.objForm = {};
		s.objForm.listid = 0;
		s.objForm.owner = 0;
		s.objForm.urlid = utility.getUrlParamValue('urlid'); // utility is available globally
		s.objForm.title = '';
		s.objForm.siid = '';
		s.objForm.rsvpid = 0;
		s.objForm.imid = 0;
		s.objForm.usealternatename = false;
		s.objForm.changemembermame = false;
		s.objForm.displayfirstname = '';
		s.objForm.displaylastname = '';
		s.objForm.firstname = '';
		s.objForm.lastname = '';
		s.objForm.email = '';
		s.objForm.savecontactinfo = false;
		s.previewOnly = utility.getUrlParamValue('previewOnly') !== 'undefined' ? utility.getUrlParamValue('previewOnly') : false;
		s.pidParam = '';

		// If invisible recaptcha is disabled on a sign up (the default), we don't need to insert any content into the DOM, so we use an empty string
		s.invisibleRecaptcha = '';
		s.recaptchaActive = s.invisibleRecaptcha.length ? true : false;
		// validatedData holds a scoped reference to the validated sign up info in ProcessSignUp, so that we can submit the sign up data from within the recaptcha check.
		s.validatedData = {};

		// Trigger a freestar/sortable event on the completion of a sign up. 
		s.$watch('complete', function(newValue, oldValue) {
			// Prevent event from running on initialization of controller.
			if(newValue === oldValue){
				return;
			}			
			if (newValue === true) {
				// Only trigger the order confirmation event if ads are enabled on the sign up
				if (s.showsegments) {
					sortableService.triggerEvent('Order_confirmation');
				}
			}
		})

		// Used to process the sign up data from within the recaptcha calls
		var submitSignupData = function(processedData) {
			return svc.processSignUp( processedData )
				.then( function(response){
					var r = util.lowerCaseKeys( response );
					if( !resultCheck( r.data ) ){
						if( typeof r.data.data === "object" && 'errormessages' in r.data.data ){
							s.errorMessages = r.data.data.errormessages;
							s.success = false;
						}
						else {
							errorHandler( r.data );
						}
						s.isProcessing = false;
						win.scrollTo(0,0);
					}
					else {
						// toggle the default ttl for the cache, so we don't get stale data
						signupPageService.toggleDefaultTtl();
						// Call code to start LiveRamp ATS
						win.startAts(r.data.data.email);
						processSignUpHander( r.data.data );
					}

				});
		}

		s.labels = {
			"submitBtn" : "Sign Up Now",
			"cancelBtn" : "Cancel",
			"deleteBtn" : "Delete",
			"breadcrumbBtn" : "Back to ",
			"signmeupfor" : "Sign me up for:",
			"contactinfo" : "Contact info:",
			"additionalinfo" : "Additional info:",
			"backtosignup" : "Back to Sign Up",
			"addtocalendar" : "Add to Calendar",
			"editmysignup" : "Edit My Sign Up",
			"editmyrsvp" : "Edit My RSVP",
			"socialshare" : "Share with Friends",
			"returntosignup" : "Return to Sign Up",
			"saveContactInfo" : "Save my contact info for use on future sign ups",
			"payLater" : "Sign Up & Pay Later"
		};

		s.standardErrors = {
			"email_invalid"     : "You must enter a valid email address.",
			"email_length"      : "Email address must not exceed 100 characters.",
			"firstname_length"  : "First name must not exceed 50 charcters.",
			"lastname_length"   : "Last name must not exceed 100 characters.",
			"quantity_invalid"  : "The quantity must be all numeric.",
			"savecontactinfo" : "You must populate the address and/or phone information when selecting this option.",
			"email_disallowed"	: "Please sign up with an individual email address.",
		};

		s.errormessage = "Oops! Something went wrong. We can't seem to find the sign up information you've requested. If this error persists, please <a href='/help'>contact support</a>.";
		s.notificationsurl = window.globalcfg.notificationsURL;

		// Method ot retrieve the countries list
		var getCountries = function(){
			globalService.getCountries().then( function(response){
				var r = util.lowerCaseKeys( response );
				if( !resultCheck( r.data ) ){
					errorHandler( r );
				} else {
					s.countries = r.data;
				}
			},
			function(result){
				errorHandler( result );
			});
		};
		getCountries();

		/**
		 * Method returns the Portal Id (pid) from the URL, or 0
		 * Simulates actions that happen in the signuppage.js Service,
		 * but here the URL is in the older format.
		 */
		var getEmbedPortalIdParam = function(){
			 var urlparts = window.location.href.split('?');
			 if( urlparts.length > 1){
				var params = urlparts[1].split('&');

				//find the pid value (PortalId) and return it
				for( var p=0, end=params.length; p<end; p++){
					if(params[p].toString().toLowerCase().includes("pid=")){
						s.pidParam = '/pid/' + params[p].replace('pid=','');
						break;
					}
				}
			 }
		};

		/** Setup the Portal Id URL Params If Necessary **/
		getEmbedPortalIdParam();


		/** helper method to setup sign up form elements **/
		var setFormElements = function(){
			// Used to determine whether to handle the form as part of a SPA or not
			s.useSinglePageApplication = svc.useSinglePageApplication;
			// setup
			s.backtosignupLink = "/go/" + s.signup.urlid.toString().trim() + s.pidParam;
			s.signupTitle = sce.trustAsHtml(s.signup.title.toString().trim());
			s.signupDesc = sce.trustAsHtml(s.signup.description.toString());
			s.datedisplay = s.signup.shortdformat;
			s.dateformat = s.signup.shortdformat.toString().replace("mm","MM");
			s.shortZone = s.signup.tzshort;
			s.nodatesignup = (parseInt(s.signup.nodate) === 1);
			s.closeLock = (s.signup.closelock > 0);
			s.modifyLock = parseInt(s.signup.modifylockdays);
			s.commentsRequired = (parseInt(s.signup.commentrequired) === 1);
			s.emailRequired = (parseInt(s.signup.emailrequired) === 1);
			s.signupQtyLimit = s.signup.qtylimit_signup;
			s.itemQtyLimit = s.signup.qtylimit_slotitems;
			s.qtyLimitEnabled = (s.signupQtyLimit > 0 || s.itemQtyLimit > 0);
			s.isrsvp = (parseInt( s.signup.usersvp ) === 1);
			s.socialshare = (parseInt(s.signup.socialshare) === 1);
			s.showsegments = s.signup.showsegments;
			s.listid = s.signup.id;
			s.signupowner = s.signup.owner;
			s.signupcontact = s.signup.contactname;
			s.signupiswepay = s.signup.iswp;
			s.wpfeepayer = s.signupiswepay && isD( s.signup.wprate.fee_payer ) ? s.signup.wprate.fee_payer : s.wpfeepayer;
			s.wprate = s.signupiswepay && isD( s.signup.wprate ) ? s.signup.wprate : {p:0,r:0};

			s.signupislumapay = s.signup.islp;
			s.lpfeepayer = s.signupislumapay && isD( s.signup.lprate.fee_payer ) ? s.signup.lprate.fee_payer : s.lpfeepayer;
			s.lprate = s.signupislumapay && isD( s.signup.lprate ) ? s.signup.lprate : {p:0,r:0};
			if( isD( s.signup.currency ) )
				s.currency_code = s.signup.currency;
			if( s.signupcontact.toString().trim() === '' )
				s.signupcontact = " the sign up creator ";
			s.linktowebsite = '';
			s.linktowebsitebtn = '';
			if( s.signup.linktowebsite.toString().length ){
				var ltw = s.signup.linktowebsite.split('|');
				if( ltw.length === 2 ){
					s.linktowebsite = ltw[1];
					s.linktowebsitebtn = ltw[0];
					s.backtosignupLink = ltw[1];
					s.labels.backtosignup = ltw[0];
					s.showreturntosulink = true;
					s.returntosulink = "/go/" + s.signup.urlid;
				}
			}

			// Only check for wepayOutage on wepay sign ups
			if (s.signupiswepay) {
				s.wepayOutage = {};
				getMerchantOutage("wepayOutage");
			}
/* Not currently used. Included here commented out in case we decide to use it in the future
			else if s.signupislumapay) {
				s.lumapayOutage = {};
				getMerchantOutage("lumapayOutage");
			}
*/

			/** do some randomize ad AB testing on the thank you page **/
			if( s.showsegments ){
				s.hAdWidth = 190;
				s.containerWidth = win.innerWidth;
				if( s.containerWidth > 1199 )
					s.hAdWidth = 330;

				// remove randomization
				// var r = Math.floor((Math.random() * 100) + 1);
				// if( r % 2 === 0 )
				s.thankYouTemplate = '/view/templates/signups/form/altthankyou.html';
			}

			// if sign up is RSVP
			if( s.isrsvp ){
				s.formMainTitle = 'My RSVP';
				s.labels.submitBtn = "RSVP Now";
				if( isD(s.attrs.rsvpid) && s.attrs.rsvpid !== '' ){
					s.editmode = true;
					s.labels.submitBtn = "Update My RSVP";

				}
				// defaults
				s.objForm.rsvpresponse = '';
				s.objForm.rsvpadult = 0;
				s.objForm.rsvpchildren = 0;
				s.objForm.rsvpitems = [];
				s.objForm.rsvpcomments = '';

				// header
				if( s.objForm.rsvpid > 0 && isD(s.signup.rsvp) ){
					s.objForm.rsvpresponse = s.signup.rsvp.rsvp.toString().toLowerCase();
					s.objForm.rsvpadult = angular.isNumber(s.signup.rsvp.rsvpcount) ? parseInt(s.signup.rsvp.rsvpcount) : 0;
					s.objForm.rsvpchildren = angular.isNumber(s.signup.rsvp.rsvpchildcount) ? parseInt(s.signup.rsvp.rsvpchildcount) : 0;
					s.objForm.rsvpcomments = s.signup.rsvp.comment;
					// if editing and name is different
					if( s.editmode && s.user.loggedin ){
						if( s.signup.rsvp.displayfirstname !== '' && (s.user.firstname.toString().trim() != s.signup.rsvp.displayfirstname.toString().trim() || s.user.lastname.toString().trim() != s.signup.rsvp.displaylastname.toString().trim()) ){
							s.objForm.usealternatename = true;
							s.objForm.displayfirstname = s.signup.rsvp.displayfirstname;
							s.objForm.displaylastname = s.signup.rsvp.displaylastname;
						}
					}
					if( s.editmode && !s.user.loggedin && s.anonymous ){
						s.objForm.displayfirstname = s.signup.rsvp.displayfirstname;
						s.objForm.displaylastname = s.signup.rsvp.displaylastname;
						s.objForm.firstname = s.signup.rsvp.displayfirstname;
						s.objForm.lastname = s.signup.rsvp.displaylastname;
						s.objForm.email = s.signup.rsvp.email;
					}
				}

				// details
				if( isD(s.signup.rsvpdetails) ){
					s.rsvpdetails = s.signup.rsvpdetails;
					s.rsvpdetails.usetime = (parseInt(s.rsvpdetails.usetime) === 1);
					s.rsvpdetails.dtstarttime = "";
					s.rsvpdetails.dtendtime = "";
					s.rsvpheader = "Will you be attending on";
					if( s.rsvpdetails.starttime !== '' ){
						try {
							s.rsvpdetails.dtstarttime = new Date( s.rsvpdetails.starttime );
							s.rsvpdetails.dtstarttime = Date.parse( s.rsvpdetails.dtstarttime );
							s.rsvpheader += " " + filter('date')(s.rsvpdetails.dtstarttime, 'EEE') + '., ' + filter('date')(s.rsvpdetails.dtstarttime, s.dateformat );
							if( s.rsvpdetails.usetime ){
								var hdrPronouns = s.rsvpdetails.endtime === '' ? " at " : " from ";
								s.rsvpheader += hdrPronouns + (filter('date')(s.rsvpdetails.dtstarttime, 'h:mma' )).toLowerCase();
							}

						} catch( e ){}
					}
					if( s.rsvpdetails.endtime !== '' ){
						try {
							s.rsvpdetails.dtendtime = new Date( s.rsvpdetails.endtime );
							s.rsvpdetails.dtendtime = Date.parse( s.rsvpdetails.dtendtime );
							if( s.rsvpdetails.usetime )
								s.rsvpheader += ' - ' + (filter('date')(s.rsvpdetails.dtendtime, 'h:mma' )).toLowerCase();

						} catch( e ){}
					}

					if( s.editmode ){
						var moddate = new Date();
						if( s.signup.closedateutc !== '' && s.closeLock > 0 ){
							var lockdatetime = new Date( s.signup.closedateutc );
							s.editLocked = ( lockdatetime < moddate );
						}
						/** for RSVP - this is not available
						else if( s.modifyLock > 0 ){
							var eventStartTime = new Date( s.rsvpdetails.starttime );
								moddate.setDate( moddate.getDate() + s.modifyLock );
							s.editLocked = (moddate > eventStartTime);
						}
						**/
					}

					s.rsvpheader = s.rsvpheader.trim();
					if( s.rsvpdetails.usetime )
						s.rsvpheader += " " + s.shortZone + "?";

						// check if there are items associated with the rsvp
						s.items = isD(s.signup.rsvpdetails.rsvpitems) && angular.isArray(s.signup.rsvpdetails.rsvpitems) ? s.signup.rsvpdetails.rsvpitems : [];
						itemHandler();

						// if there are items, build the list
						if( s.items.length ){

							// let's record the initial available quantities
							angular.forEach( s.items, function(obj,key){
								// if quantity limit is enabled for items
								if( s.qtyLimitEnabled && s.itemQtyLimit > 0 )
									s.rItemQtyLookup[obj.slotitemid] = ( s.itemQtyLimit < obj.availableqty ) ? s.itemQtyLimit : obj.availableqty;
								else
									s.rItemQtyLookup[obj.slotitemid] = obj.availableqty;

								if( s.rItemQtyLookup[obj.slotitemid] > 0 )
									s.rsvpitemsavailable = true;
							});

							if( s.objForm.rsvpid === 0 ){
								if( s.rsvpitemsavailable )
									s.addMoreRSVPItem();
							}
							else {
								if( isD(s.signup.rsvpdetails.memberitems) && angular.isArray(s.signup.rsvpdetails.memberitems) ){

									angular.forEach( s.signup.rsvpdetails.memberitems, function(obj,key){
										var thisAvailableQty = (parseInt(obj.myqty) + s.rItemQtyLookup[obj.slotitemid]);
										var temp = {};
											temp.slotError = '';
											temp.qtyError = '';
											temp.commentError = false;
											temp.items = [getItemBySlotItemID( obj.slotitemid )];
											temp.item = lookupItemBySlotItemID(obj.slotitemid);
											temp.itemmemberid = obj.itemmemberid;
											temp.slotitemid = obj.slotitemid;
											temp.itemid = lookupItemIdBySlotItemID(obj.slotitemid);
											temp.mycomment = obj.mycomment;
											temp.myqty = obj.myqty;
											temp.deleted = false;
											temp.availableqty = ( s.qtyLimitEnabled && s.itemQtyLimit > 0 && thisAvailableQty > s.itemQtyLimit ) ? s.itemQtyLimit : thisAvailableQty;
											temp.qty = qtyLookupBySlotItemID( obj.slotitemid );
										s.objForm.rsvpitems.push(temp);
									});
								}
								if( !s.objForm.rsvpitems.length ){
									if( s.rsvpitemsavailable )
										s.addMoreRSVPItem();
								}
								else {
									s.rsvpitemsavailable = true;
								}
							}
						}

				} // end rsvpdetails

			}
			else {
				// standard sign up
				if( isD(s.attrs.imid) && s.attrs.imid !== '' ){
					s.editmode = true;
					s.labels.submitBtn = "Update My Sign Up";
					s.labels.payLater = "Update & Pay Later";
				}
			}

			// basic form object
			s.objForm.listid = s.signup.id;
			s.objForm.owner = s.signup.owner;
			s.objForm.urlid = s.signup.urlid;
			s.objForm.title = s.signup.title;

			if( s.signup.hascustomfields && isD(s.signup.customfields) && angular.isArray(s.signup.customfields) )
				customQuestionHander();
		};

	    /* Get merchant Outage Info */
	    var getMerchantOutage = function(feature) {
	        var data = { "feature": feature };
	        svc.getMerchantOutage(data)
	            .then(function(result){
	                result = util.lowerCaseKeys(result.data);
	                if (result.success){
	                    // Handle success
	                    s.wepayOutage = result.data;
	                } else {
	                    util.showAlert(result.message[0]);
	                }
	            });
	    };


		/** requests to get all the sign up information **/
		svc.getUserInfo()
			.then( function( member ){
				var r = util.lowerCaseKeys( member );
				if( !resultCheck( r.data ) ){
					s.asyncSuccess = false;
					errorHandler( r.data );
				}
				else {
					s.user = r.data.data;
					s.user.loggedin = ( angular.isDefined( s.user.memberid ) && parseInt(s.user.memberid) > 0 );
					var d = {};
					d.fuse = 's.ProcessSignup';
					return globalService.checkNewAdDirective(d);
				}
			})
			.then( function( newad ) {
				var r = util.lowerCaseKeys( newad );
				if( resultCheck( r.data ) ){
					s.usenewaddirective = r.data.data;

					if( s.usenewaddirective ){
						s.adconfig.themeid = s.signup.themeid;
						var adnetworks = typeof $rootScope.adnetworkdatafile !== 'undefined' && typeof $rootScope.adnetworkdatafile.networks !== 'undefined' ? $rootScope.adnetworkdatafile.networks : {};
						s.adconfig.network = adService.getAdNetwork(s.adconfig,adnetworks);
					}			
				}
				// get attrs
				var d = {};
				if( s.previewOnly ){
					d.success = true;
					d.message = [];
					d.data = {};
					d.data.listid = utility.getUrlParamValue('listid') !== 'undefined' ? utility.getUrlParamValue('listid') : 0;
					d.data.siid = utility.getUrlParamValue('siid') !== 'undefined' ? utility.getUrlParamValue('siid') : 0;
					var resp = {};
						resp.data = d;
					var deferred = $q.defer();
						deferred.resolve( resp );
					return deferred.promise;
				} else {
					d.urlid = s.objForm.urlid;
					return svc.getSignUpFormAttrs(d);
				}
			})
			.then(function( attrs ){
				if( s.asyncSuccess ){
					var r = util.lowerCaseKeys( attrs );
					if( !resultCheck( r.data ) ){
						s.asyncSuccess = false;
						errorHandler( r.data );
					}
					else {
						s.attrs = r.data.data;
						s.objForm.siid = isD( s.attrs.siid ) && s.attrs.siid !== '' ? s.attrs.siid.toString().split(',') : ( isD(s.attrs.siids) && s.attrs.siids !== '' ? s.attrs.siids.toString().split(',') : [] );

						var d = {};
							d.includeAdvanceDetails = true;
						if( s.previewOnly ){
							d.previewOnly = true;
							d.listid = s.attrs.listid;
							d.urlid = '';
						} else {
							d.urlid = s.attrs.urlid;
						}
						if( isD(s.attrs.rsvpid) && s.attrs.rsvpid !== '' ){
							d.rsvpid = s.attrs.rsvpid;
							s.objForm.rsvpid = d.rsvpid;
							if( isD(s.attrs.token) && s.attrs.token !== '' ){
								s.anonymous = true;
							}
							else if( !s.user.loggedin ){
								// will only reach this if the session timed out
								s.asyncSuccess = false;
							}
						}
						if( isD(s.attrs.imid) && s.attrs.imid !== '' ){
							d.imid = s.attrs.imid;
							s.objForm.imid = d.imid;
							if( isD(s.attrs.token) && s.attrs.token !== '' ){
								s.anonymous = true;
							}
							else if( !s.user.loggedin ){
								// will only reach this if the session timed out
								s.asyncSuccess = false;
							}
						}
						if( s.asyncSuccess )
							return signupPageService.getsignup( d );
						else
							util.showMagnificAlert('Your session has expired. <a href="/index.cfm?go=c.login">Login</a> again to edit your sign up.');
					}
				}
			})
			.then( function( signup ){
				if( s.asyncSuccess ){
					var r = util.lowerCaseKeys( signup );
					if( !resultCheck( r.data ) ){
						s.asyncSuccess = false;
						errorHandler( r.data );
					}
					else {
						s.signup = r.data.data;

						if( !angular.isDefined(s.signup.id) || parseInt(s.signup.id) === 0 ){
							s.asyncSuccess = false;
							util.showMagnificAlert('The sign up is no longer available.');
						}
						else {
							// If the sign up is valid, fetch the script tag for the invisible info as soon as possible, and mount it into the dom
							if (s.signup.signupprotection) {
								globalService.getInvisibleReCaptcha(s.signup.owner).then(function(recaptchaResponse) {
									var response = util.lowerCaseKeys( recaptchaResponse );										
									if (util.ajaxResultInvalid(response)) {
										// If we fail to get the recaptcha script from the server, we just let the user sign up as usual.	
									} else {
										s.invisibleRecaptcha = sce.trustAsHtml(response.data.data.snippet);
										s.recaptchaActive = response.data.data.snippet.length ? true : false;
									}
									
								});

							}

							setFormElements();
							if( !s.objForm.siid.length && !s.isrsvp ){
								s.asyncSuccess = false;
								s.noSlotSelected();
							}
							else {
								s.signupLoaded = true;
								var theme = {};
									theme.themeID = s.signup.themeid;
									theme.listid = s.signup.id;
									theme.returnType = 'class';
								return signupPageService.getSignupTheme( theme );
							}
						}

					}
				}
			})
			.then( function( theme ){
				if( s.asyncSuccess ){
					var r = util.lowerCaseKeys( theme );
					if( !resultCheck( r.data ) ){
						s.asyncSuccess = false;
						errorHandler( r.data );
					}
					else {
						s.theme = r.data.data;
						/** build dynamic classes **/
						s.createSignUpStyle();
						/** get the items the member is sign up for **/
						if( parseInt(s.signup.usersvp) !== 1 ){
							var d = {};
								d.listid = s.signup.id;
								d.siid = s.objForm.siid;
								d.hasProductImages = typeof s.signup.productimages !== 'undefined' ? s.signup.productimages : false;
							if( isD(s.attrs.imid) && s.attrs.imid !== '' ){
								d.imid = s.attrs.imid;
								s.objForm.imid = d.imid;
							}
							return svc.getSignUpFormItems( d );
						}
					}
				}
			})
			.then( function( items ){
				if( s.asyncSuccess && typeof items !== "undefined" ){
					var r = util.lowerCaseKeys( items );
					if( !resultCheck( r.data ) ){
						s.asyncSuccess = false;
						errorHandler( r.data );
					}
					else {
						s.items = angular.isArray(r.data.data) ? r.data.data : [];
						itemHandler();

						// if wepay and have paymentitems
						if( s.signupiswepay && s.hasPayItems ){
							if( navigator.userAgent.indexOf("MSIE 7") >= 0 || navigator.userAgent.indexOf("MSIE 8") >= 0 || navigator.userAgent.indexOf("MSIE 9") >= 0 ){
								s.errormessage = 'Your browser is not currently supported. The minimum version of Internet Explorer we support is version 10. Alternately, you can use other browsers like <a href="https://www.google.com/chrome/browser/" target="_blank">Chrome</a> or <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" class="smalllink">FireFox</a>.';
								s.asyncSuccess = false;
								s.signupLoaded = false;
							}
							else if( !navigator.cookieEnabled ){
								s.errormessage = "Oops! Looks like your browser's cookies are turned off. Our application requires that the cookie functionality must be turned on.";
								s.asyncSuccess = false;
								s.signupLoaded = false;
							}
						} else if( s.signupislumapay && s.hasPayItems ) {
							// if lumapay and have paymentitems
/* TO DO: Check for incompatibale browsers */
							if( navigator.userAgent.indexOf("MSIE ") >= 0 ){
								s.errormessage = 'Your browser is not currently supported. LumaPay payments are not supported in Internet Explorer. You can use other browsers like <a href="https://www.google.com/chrome/browser/" target="_blank">Chrome</a> or <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" class="smalllink">FireFox</a>.';
								s.asyncSuccess = false;
								s.signupLoaded = false;
							}
						}
					}
				}
			})
			.then( function( wpresponse ){
				if( s.asyncSuccess ){
					if( typeof wpresponse !== "undefined" ){
						var r = util.lowerCaseKeys( wpresponse );
						if( resultCheck( r.data ) ){
							setWePayCookie( r.data.data );
						}
					}
					else {
						// If the sign up owner requires the user to have an account launch the registration modal.
						if( !s.user.loggedin && s.signup.accountrequired ){
							s.login( true );
						}
						s.initialized = true;
						refreshSelectPicker();
					}
				}
				else {
					s.initialized = true;
					refreshSelectPicker();
				}
				win.scrollTo(0,0);
			});

		/** helper method **/


		/** watch rsvp response **/
		s.$watch("objForm.rsvpresponse",function(nval,oval){
			s.labels.signmeupfor = ( nval === 'n' ) ? "I am not attending the event, but sign me up for:" : "Sign me up for:";
		});

		s.noSlotSelected = function(){
			var alertWindow = modal.open({
				templateUrl : '/view/templates/signups/form/alert.html',
				controller : 'alertController',
				resolve : {
					message : function(){
						return 'You must select one or more slots to sign up for.';
					},
					messagetitle : function(){
						return 'Invalid Request';
					}
				}
			});

			alertWindow.result.then(
				function(){
					win.location.href = s.winorigin + "/go/" + s.attrs.urlid;
				},
				function(){
					win.location.href = s.winorigin + "/go/" + s.attrs.urlid;
				});
		};

		s.signup_Template = function(){
			var template = s.isrsvp ? 'signupformrsvp' : 'signupformstandard';
			return "/view/templates/signups/form/" + lowerCaseIt(template) + ".html";
		};

		/** method to create dynamic sign up styles **/
		s.createSignUpStyle = function(){
			// this is where our dynamic style container will be
			var styleContainer = angular.element( document.querySelector( '#styleContainer' ) );
			// create a style tag containing all the classes
			var dStyles = angular.element( '<style type="text/css">' + s.theme + '</style>' );
			// append the style to the container
			styleContainer.append( dStyles );
		};

		/** helper method to create a numeric item array for quantity dropdown **/
		s.getQtyArray = function( item, includezero ){
			var qty = 0;
			var i = [];
			var j = isD( includezero ) ? 0 : 1;
			if( angular.isNumber(item) ){
				qty = item;
			} else {
				qty = item.availableqty;
				if( item.itemmemberid > 0 && item.myqty > 0 )
					qty = item.myqty + item.availableqty;
				if( s.qtyLimitEnabled && s.itemQtyLimit > 0 )
					qty = s.itemQtyLimit < qty ? s.itemQtyLimit : qty;
			}
			// create array
			for( j; j <= qty; j++ )
				i.push( j );

			return i;
		};


		/** helper method to calculate line item price when applicable **/
		s.calculateLinePrice = function(){
			s.totalPrice = 0;
			s.servicefee = 0;

			var numMatch = /^\d+$/;
			// if sign up has a quantity discount, calculate aggregate items
			var calcAggregate = false;	// flag to determine if calculating aggregates is required
			var qtyArr = [];	// variable to store aggregate quantities by itemid
			// iterate items to determine if quantity discount applicable; set calc flag if so
			for( var i = 0; i < s.items.length; i++ ){
				if( s.items[i].discountisavailable && s.items[i].discounttype == 'Q'){
					calcAggregate = true;
					break;
				}
			}
			// if flag set, get aggregate quantities selected
			if( calcAggregate ){
				qtyArr = getTotalQuantities(s.items);
			}

			angular.forEach( s.items, function(obj,key){
				var _thisPrice,_thisminprice,tempPrice = 0;
				delete s.errorMessages['itemqtylimit_' + obj.id];
				delete s.errorMessages['priceminimum_' + obj.id];
				obj.priceError = false;
				obj.qtyError = false;
				if( !isD(obj.myqty) || obj.myqty === "" || obj.myqty < 0 ){
					obj.qtyError = true;
					s.errorMessage['itemqtylimit_' + obj.id] = 'Quantity must be between 1 and 999999.';
				}
				else if( s.arrpaytypes.indexOf( obj.paymenttype ) >= 0  ){
					_thisminprice = isD(obj.minimumamount) ? toFloat(obj.minimumamount).toFixed(2) : 0.00;
					_thisPrice = isD(obj.price) && obj.price !== '' ? toFloat(obj.price) : 0;
					tempPrice = obj.price.toString().replace('$','').replace('.','');
					// verify price is valid
					if( tempPrice.match(numMatch) === null || ( typeof _thisPrice === 'number' && isNaN(_thisPrice) ) ){
						// obj.price = null;
						s.errorMessages['priceminimum_' + obj.id] = 'Invalid amount. Value must be numeric.';
						obj.priceError = true;
						return;
					}

					if( obj.paymenttype === 'options' ){
						obj.price = angular.isObject(obj.paymentOptionSelected) && isD(obj.paymentOptionSelected.value) ? toFloat(obj.paymentOptionSelected.value) : 0.00;
						_thisPrice = isD(obj.price) && obj.price !== '' ? toFloat(obj.price) : 0;
					}
					else if( obj.paymenttype === 'noset' ){
						// obj.price = toFloat(obj.price).toFixed(2);
					}
					if( _thisPrice < _thisminprice ){
						s.errorMessages['priceminimum_' + obj.id] = 'A minimum amount of ' + s.currency_symbol + _thisminprice + ' is required.';
						obj.priceError = true;
						return;
					}

					// if discount applies, adjust price and total
					if( obj.discountisavailable ){
						// if product has a quantity criteria, test to see if it applies
						if( obj.discounttype == 'Q' ){
							// variable to store aggregate quantity for item
							var itemTotalQty = 0;
							// get aggregate quantity being purchased
							qtyArr.forEach( function(itm){
								if(itm.itemid == obj.itemid){
									itemTotalQty = itm.myqty;
								}
							});
							// meets quantity criteria
							if( itemTotalQty >= obj.discountcriteria ){
								obj.paymentAmount = parseInt(obj.myqty) * obj.discountprice;
								s.totalPrice += obj.paymentAmount;
							}
							else{
								obj.paymentAmount = parseInt(obj.myqty) * _thisPrice;
								s.totalPrice += obj.paymentAmount;
							}
						}
						// if product has date criteria, apply discount price
						if( obj.discounttype == 'D' ){
							// *****
							// testing expiration date is overkill here since it is already assessed when setting discountisavailable = true
							//   but adding it in case the date has changed since first page load
							// *****
							// if expiration date in the future
							var currentDate = new Date();
							//convert db date into js date - db format is like {d '2018-01-31'}
							var temp = obj.discountcriteria.replace(/[{d' }]/g,"").split(/[- :]/);
							var expirationDate = new Date(temp[0], temp[1]-1, temp[2], "23", "59", "59");

							// if discount meets date criteria
							if( typeof expirationDate.getTime() === 'number' && !isNaN(expirationDate.getTime()) && expirationDate >= currentDate ){
								obj.paymentAmount = parseInt(obj.myqty) * obj.discountprice;
								s.totalPrice += obj.paymentAmount;
							}
						}

					}
					else{	// no discount applies
						obj.paymentAmount = parseInt(obj.myqty) * _thisPrice;
						s.totalPrice += obj.paymentAmount;
					}
				}
			});
			// if this is a wepay sign up and there's a rate
			if( s.signupiswepay && s.wprate.p > 0 && s.totalPrice > 0){
				// s.wprate.p & s.wprate.t
				// if fees being paid by buyer, add service fee
				if( s.wpfeepayer == 'payer_from_app' ){
					s.servicefee = s.wprate.t + (s.totalPrice * s.wprate.p);
				}
				s.totalPrice += s.servicefee;
			}
			// if this is a lumapay sign up and there's a rate
			if( s.signupislumapay && s.lprate.p > 0 && s.totalPrice > 0){
				// s.lprate.p & s.wlprate.t
				// if fees being paid by buyer, add service fee
				if( s.lpfeepayer == 'payer_from_app' ){
					s.servicefee = s.lprate.t + (s.totalPrice * s.lprate.p);
				}
				s.totalPrice += s.servicefee;
			}
		};

		s.setPriceTwoDecimals = function() {
			angular.forEach( s.items, function(obj,key){
				// convert only when there are no errors
				if( !obj.priceError && !obj.qtyError ){
					obj.price = toFloat(obj.price).toFixed(2);
					obj.minimumamount = toFloat(obj.minimumamount).toFixed(2);
				}
			});
		};

		/** method to check if an error exist for a given form element **/
		s.errorExists = function( elem ){
			return (elem in s.errorMessages );
		};

		/** method returns the error message for a given element **/
		s.getError = function( elem ){
			return (elem in s.errorMessages ) ? s.errorMessages[elem] : '';
		};

		/** logout method **/
		s.logout = function(){
			if(s.previewOnly )
				return;
			s.asyncSuccess = true;
			authSvc.logoutUser()
				.then( function( response ){
					var r = util.lowerCaseKeys( response );
					if( !resultCheck( r.data ) ){
						s.asyncSuccess = false;
						errorHandler( r.data );
					}
					else {
						s.user = {};
						if (s.useSinglePageApplication) {
							signupPageService.setMemberInfo({});
							svc.cachedMemberinfo = {};
						}
						s.user.loggedin = false;
						if( isD(s.attrs.thismemberid) )
							delete s.attrs.thismemberid;
						if( isD(s.attrs.mid) )
							delete s.attrs.mid;

						if( s.isrsvp ){
							if( isD(s.attrs.rsvpid) && s.attrs.rsvpid !== '' )
								delete s.attrs.rsvpid;
							if( isD(s.objForm.rsvpid) && s.objForm.rsvpid > 0 )
								s.objForm.rsvpid = 0;

							if( isD(s.objForm.rsvpitems) && angular.isArray(s.objForm.rsvpitems) ){
								angular.forEach(s.objForm.rsvpitems, function(obj,key){
									if( isD(obj.itemmemberid) && obj.itemmemberid > 0 )
										obj.itemmemberid = 0;
								});
							}
						}

						// update upper main navivation menus
						updateMenu();
					}
				})
				.finally(() => {
					window.sugTagManager.reset();
				});
		};

		/** login method **/
		s.login = function( required ){
			// if the sign up is white-labeled, then we don't want the user to login at all
			if( typeof s.signupinfo == 'undefined' || s.signupinfo.removebranding == false ){
				var loginRequired = typeof required !== 'undefined' ? required : false;
				var loginWindow = modal.open({
					templateUrl : '/view/templates/main/login.html',
					controller : 'authenticationController',
					resolve : {
						loginRequired : function(){
							return loginRequired;
						},
						loginMessage: function(){
							return 'For added security, the sign up creator requires you to have an account at SignUpGenius to sign up. Login or register below to continue.';
						},
						register: function(){
							return ( !s.user.loggedin && s.signup.accountrequired );
						},
						registerDisabled: function () {
							return false;
						}
					}

				});

				loginWindow.result.then(
					function( response ){
						var r = response;
						if( isD(r.status) && r.status === 'loggedin' && isD(r.data) && isD( r.data.memberid ) && parseInt(r.data.memberid) > 0 ){
							s.user = r.data;
							if (s.useSinglePageApplication) {
								// Updated cached member info
								signupPageService.setMemberInfo(s.user);
								svc.cachedMemberinfo = s.user;
							}
							s.user.loggedin = true;
							// update upper main navivation menus
							updateMenu();
						}
					});
			}
		};


		s.register = function(){
			var loginWindow = modal.open({
				templateUrl : '/view/templates/main/login.html',
				controller : 'authenticationController',
				resolve : {
					loginRequired : function(){
						return false;
					},
					loginMessage: function(){
						return '';
					},
					register: function(){
						return true;
					},
					registerDisabled: function () {
						return false;
					}
				}
			});

			loginWindow.result.then(
				function( response ){
					var r = response;
					if( isD(r.status) && r.status === 'loggedin' && isD(r.data) && isD( r.data.memberid ) && parseInt(r.data.memberid) > 0 ){
						s.user = r.data;
						if (s.useSinglePageApplication) {
							// Updated cached member info
							signupPageService.setMemberInfo(s.user);
							svc.cachedMemberinfo = s.user;
						}
					s.user.loggedin = true;
						// update upper main navivation menus
						updateMenu();
					}
				});
		};

		/** select input handlers **/
		s.selectHandler = function( q ){
			var id = q.myvalue;
			var cid = 0;

			// the only handler we have for now is the state/country selection
			if( lowerCaseIt(q.fieldname) === 'state' ){
				id = q.myvalue;
				cid = 0;
				s.selectedState = q.myvalue;
				angular.forEach( q.fieldvalues, function(obj,key){
					if( id == obj.optionval )
						cid = obj.countryid;
				});
				if( cid !== undefined && cid > 0 ){
					angular.forEach( s.cq_address, function(obj,key){
						if( obj.fieldname.toString().toLowerCase() === 'country' )
							obj.myvalue = cid;
					});
				}
			}
			else if( lowerCaseIt(q.fieldname) === 'country' ){
				cid = q.myvalue;
				s.selectedCountry = cid;
				s.filterStates();
				// hard exception for US and Canada
				if( cid == 37 || cid == 223 ){
					s.disableState = false;
					angular.forEach( s.cq_address, function(obj,key){
						if( obj.fieldname.toString().toLowerCase() === 'state' && obj.myvalue !== '' ){
							if( obj.myvalue == 'NA' ){
								obj.myvalue = '';
							}
							else if( cid == 37 ){
								// validate against canada states
								if( s.canadianStates.indexOf(obj.myvalue) < 0 )
									obj.myvalue = '';
							}
							else if( cid == 223 ){
								// validate against us states
								if( s.usStates.indexOf(obj.myvalue) < 0 )
									obj.myvalue = '';
							}
						}
					});
				}
				else {
					s.disableState = true;
					angular.forEach( s.cq_address, function(obj,key){
						if( obj.fieldname.toString().toLowerCase() === 'state' ){
							obj.myvalue = 'NA';
						}
					});
				}
			}
			refreshSelectPicker();
		};

		/** helper method to filter states **/
		s.filterStates = function(){
			s.filteredStates = [];
			if( s.selectedCountry == 37 || s.selectedCountry == 223 ){
				angular.forEach( s.states, function(obj,key){
					if( obj.optionval === '' )
						s.filteredStates.unshift( obj );
					else if( obj.optionval === 'NA' )
						s.filteredStates.splice( 1,0,obj );
					else if( obj.countryid == s.selectedCountry )
						s.filteredStates.push( obj );
				});
			}
			else {
				angular.copy( s.states, s.filteredStates );
			}
		};

		/** method for transposing some specific labels **/
		s.cq_label = function( label ){
			var field_name = label;
			switch ( lowerCaseIt(field_name) ){
				case 'address1':
					field_name = 'Address 1';
					break;
				case 'address2':
					field_name = 'Address 2';
					break;
				case 'phonetype':
					field_name = 'Phone Type';
					break;
				case 'zipcode':
					field_name = 'Postal Code';
					break;
				case 'state':
					field_name = 'State/Province';
					break;
			}
			return field_name;
		};

		/** form presentation for some specific types **/
		s.showHorizontal = function( label ){
			var fields = ['address1','address2','city','state','zipcode','country','phone','phonetype'];
			return fields.indexOf( lowerCaseIt(label) ) >= 0 ? true : false;
		};

		s.cq_Template = function( type ){
			if( type.toLowerCase() === 'address1' || type.toLowerCase() === 'address2' || type.toLowerCase() === 'city' || type.toLowerCase() === 'zipcode' )
				type = 'Text';
			else if( type.toLowerCase() === 'country' || type.toLowerCase() === 'state' )
				type = 'Select';
			return "/view/templates/signups/form/cq_" + lowerCaseIt(type) + ".html";
		};

		s.getMaxVal = function( val ){
			return ( parseInt(val) === 0 ) ? "" : val;
		};

		/** sign up process **/
		s.ProcessSignUp = function( paylater ){			
			if(s.previewOnly )
				return;
			// reset
			s.errorMessages = {};
			s.success = true;
			s.isProcessing = true;

			// On page load, launch registration modal if the sign up requires an account.
			if( !s.user.loggedin && s.signup.accountrequired ){
				s.login( true );
				s.isProcessing = false;
				return;
			}

			// client-side form validations first
			validateForm();
			if( !s.success ){
				if (s.recaptchaActive) {
					win.grecaptcha.reset()
				}
				s.isProcessing = false;
				win.scrollTo(0,0);
				return;
			}

			// validate custom fields if applicable
			if( s.signup.hascustomfields ){
				validateCustomFields();
				if( !s.success ){
					s.isProcessing = false;
					win.scrollTo(0,0);
					return;
				}
			}

			


			// all valid? sign up!!!
			var data = {};
				data = s.objForm;
				data.type = (s.isrsvp) ? 'rsvp' : 'standard';
				data.source = 'main';
				if( !s.isrsvp )
					data.items = s.items;
				if( s.isrsvp ){
					data.slotid = s.rsvpdetails.slotid;
					if( data.rsvpresponse.toString().toLowerCase() === 'n' ){
						s.objForm.rsvpadult = 0;
						s.objForm.rsvpchildren = 0;
						data.rsvpadult = 0;
						data.rsvpchildren = 0;
					}
				}
				data.member = s.user;
				data.isLoggedin = false;
				if( s.user.loggedin ){
					data.isLoggedin = true;
					data.firstname = s.user.firstname;
					data.lastname = s.user.lastname;
					if( !s.objForm.usealternatename ){
						data.displayfirstname = s.objForm.firstname;
						data.displaylastname = s.objForm.lastname;
					}
					else {
						if( !s.objForm.displayfirstname.toString().length )
							data.displayfirstname = s.user.firstname;
						if( !s.objForm.displaylastname.toString().length )
							data.displaylastname = s.user.lastname;
					}
				}
				else {
					// if the user is not logged in
					data.displayfirstname = s.objForm.firstname;
					data.displaylastname = s.objForm.lastname;
				}
				if( s.signup.hascustomfields ){
					data.customFields = [];
					if( s.customFields.length )
						data.customFields = data.customFields.concat(s.customFields);
					if( s.cq_address.length )
						data.customFields = data.customFields.concat(s.cq_address);
					if( s.cq_phone.length ){
						var tmp_cq_phone = [];
						angular.copy(s.cq_phone,tmp_cq_phone);
						angular.forEach(tmp_cq_phone,function(obj,key){
							obj.fieldtype = obj.fieldname;
						});
						data.customFields = data.customFields.concat(tmp_cq_phone);
					}
				}
				data.payLater = false;
				if( s.hasPayItems && !s.paymentRequired && typeof paylater !== 'undefined' )
					data.payLater = true;

				// SUG-6585: Turning this off for now - per the requirements, it needs to be so that it can be renabled if needed
				// data.page_experience = win.sug_data.page_experience;
			// move the validated data up to the controller scope so that the callback for the recaptcha has access to it
			s.validatedData = data;			
			// Call the recaptcha library
			s.executeRecaptcha();

		};

		/** When invoking the invisible recaptcha programatically, you need to call the execute() method on the grecaptcha object on the Window object.
		 * 
		*/
		s.executeRecaptcha = function(data) {
			// If the invisible recaptcha feature is enabled, execute the recaptcha
			if (s.recaptchaActive) {
				win.grecaptcha.execute();
			} else {
				// If recaptcha isn't present, submit the validated data as normal.				
				submitSignupData(s.validatedData)
			}
		}

		/** Callback for invisible recaptcha where the user's token is verified and then if accepted, the sign up process is completed. This is attached to the the window object as a global function as the invisible recaptcha requires a globally scoped callback function that it can invoke with a token after the recaptcha service has been contacted.
		 * 
		 * @param {string} token - string token returned passed into the callback by Google's invisible recaptcha client
		 */
		win.invokeCallback = function (token) { 
			// validate the token that the invisible recaptcha passes into this callback function
			globalService.validateInvisibleReCaptcha(token).then(function(validationResponse) {
				var response = util.lowerCaseKeys(validationResponse);
				if (util.ajaxResultInvalid(response)) {
					util.showMagnificAlert('Invalid captcha response.');
				} else {
					// If the token is valid, process the sign up
					if (response.data.data) {					
						submitSignupData(s.validatedData)						
					} else {
						// Otherwise throw an error modal and prevent the sign up from happening for the user.
						util.showMagnificAlert('Invalid captcha response.');
					}
				}
			})
		}



		/** if user is cancelling out of the form - clean up the items in their "cart" **/
		s.cancel = function(){
			if(s.previewOnly)
				return;
			svc.cancelForm()
				.then( function(response){
					if (s.useSinglePageApplication) {
						// When using the SPA, return user to base route
						location.path("/");
					} else {
						win.location.href = s.signup.fullurl + s.pidParam;
					}
				});
		};

		/** helper method to set item name of the selected item **/
		s.updateSelectedItem = function( item ){
			var deletedItems = [];
			var idx = '';
			angular.forEach( s.items, function(obj,key){
				if( obj.slotitemid == item.slotitemid ){
					item.item = obj.item;
					item.availableqty = s.rItemQtyLookup[item.slotitemid];
					item.qty = obj.qty;
					if( item.availableqty === 1 )
						item.myqty = 1;
				}
			});

			angular.forEach( s.objForm.rsvpitems, function(obj,key){
				if( obj.deleted && item.slotitemid === obj.slotitemid && obj.itemmemberid > 0 && item.itemmemberid === 0 ){
					idx = key;
					item.itemmemberid = obj.itemmemberid;
				}
			});

			if( idx !== '' && idx >= 0 )
				s.objForm.rsvpitems.splice(idx, 1);

			refreshSelectPicker();
		};

		/** helper method to create proper label **/
		s.getPaymentOptionLabel = function(option){
			return option.label + ' - ' + s.currency_symbol + toFloat( option.value );
		};

		/** method for adding empty rows to the rsvp item rows **/
		s.addMoreRSVPItem = function(){

			var insert = true;
			var arrUnfilled = [];
			var finalUnfilled = [];
			var lookup = {};

			// let's make sure there's only 1 empty row at a time
			angular.forEach( s.objForm.rsvpitems, function(obj,key){
				if( !obj.deleted )
					lookup[obj.slotitemid] = true;
				if( obj.slotitemid === 0 )
					insert = false;
			});

			if( insert ){
				angular.forEach( s.items, function(obj,key){
					if( obj.availableqty > 0 )
						arrUnfilled.push( obj );
				});

				if( arrUnfilled.length ){
					var temp = {};
						temp.items = arrUnfilled;
						temp.item = '';
						temp.itemmemberid = 0;
						temp.slotitemid = 0;
						temp.itemid = 0;
						temp.mycomment = '';
						temp.myqty = 0;
						temp.deleted = false;
						temp.availableqty = 0;
						temp.qty = 0;
						temp.slotError = '';
						temp.qtyError = '';
						temp.commentError = false;
					s.objForm.rsvpitems.push(temp);
				}
				else {
					var slottitle = s.signup.slottitle.toString().trim() !== '' ? s.signup.slottitle.toString().trim() : "Available slots";
					util.showMagnificAlert( slottitle + ' filled.' );
				}
			}
			refreshSelectPicker();
		};

		/** method for removing rsvp related items **/
		s.removeRSVPItem = function(item){
			var moreItems = false;
			var idx = s.objForm.rsvpitems.indexOf(item);
			if( idx >= 0 ){
				// if this is an edit and itemmember is defined, we just mark it so we can delete it from the database
				if( s.objForm.rsvpitems[idx].itemmemberid > 0 )
					s.objForm.rsvpitems[idx].deleted = true;
				else
					s.objForm.rsvpitems.splice(idx, 1); // we remove the record from the array. no need to do anything in the backend side
			}

			// if all elements are removed, insert a blank one.
			angular.forEach( s.objForm.rsvpitems, function(obj,key){
				if( !obj.deleted )
					moreItems = true;
			});


			// create at least a blank item
			if( !moreItems )
				s.addMoreRSVPItem();
		};

		/** helper method to set rsvp response **/
		s.rsvpMe = function(r){
			s.objForm.rsvpresponse = r;
			if( r !== 'n' ){
				timeout(function(){
					angular.element('.rsvpnumadult').selectpicker('refresh');
					angular.element('.rsvpnumchild').selectpicker('refresh');
				},0);
			}
		};

		/** method for social media sharing **/
		s.share = function( media ){
			var signupurl = isD(s.signup.fullurl) && s.signup.fullurl !== '' ? s.signup.fullurl : encodeURIComponent(s.winorigin + "/go/" + s.attrs.urlid);
			var signupimage = s.signup.signupimage !== '' ? encodeURIComponent(s.signup.signupimage) : encodeURIComponent(s.winorigin + "/images/theme/" + s.signup.themeid + "-large.jpg");
			var mediaurl = '';
			var winsize = '';
			var py = 0;
			var px = 0;
			var tweettext = encodeURIComponent("I just signed up on the " + s.signup.title.toString().trim() + " page - ");
			if( media === 'fb' ){
				winsize = "width=640,height=400";
				py = win.top.outerHeight / 2 + win.top.screenY - ( 400 / 2);
				px = win.top.outerWidth / 2 + win.top.screenX - ( 640 / 2);
				mediaurl = "http://www.facebook.com/sharer/sharer.php?u=" + signupurl + "&src=sp";
			}
			else if( media === 'pinterest' ){
				winsize = "width=740,height=700";
				py = win.top.outerHeight / 2 + win.top.screenY - ( 700 / 2);
				px = win.top.outerWidth / 2 + win.top.screenX - ( 740 / 2);
				mediaurl = "http://pinterest.com/pin/create/button/?url=" + signupurl + "&media=" + signupimage + "&description=" + tweettext + '%20' + signupurl;
			}
			else if( media === 'twitter' ){
				winsize = "width=640,height=320";
				py = win.top.outerHeight / 2 + win.top.screenY - ( 320 / 2);
				px = win.top.outerWidth / 2 + win.top.screenX - ( 640 / 2);
				mediaurl = "https://twitter.com/share?text=" + tweettext + "&url=" + signupurl;
			}

			// open the window
			winsize += ",top=" + py + ",left=" + px;
			win.open(mediaurl,'_blank',winsize);
		};




		/** method to get ics **/
		s.getICS = function( cal ){
			var icalLink = '';
			if( s.isrsvp ){
				icalLink = cal in s.calLinks ? s.calLinks[cal] : '';
			}
			else {
				if( cal === 'ical' ){
					icalLink = cal in s.calLinks ? s.calLinks[cal] : '';
				}
				else {
					if( s.myitems.length === 1 ){
						icalLink = s.myitems[0].callink || '';
					}
					else {
						// we will need to do a modal window to show the list of calendars
						var calendarWindow = modal.open({
							templateUrl : '/view/templates/signups/form/multicalendardownload.html',
							controller : 'multicalendarController',
							resolve : {
								items : function(){
									return s.myitems;
								},
								icsCal : function(){
									return isD(s.calLinks.ical) ? s.calLinks.ical : '';
								}
							}
						});

						calendarWindow.result.then(
							function( response ){
								// do nothing
							});
					} // end
				}
			}
			if( icalLink.length )
				win.open(icalLink);
		};

		s.getContactInfoValue = function( fieldtype ){
			var contactInfo = s.user.membercontact || {'address1':'','address2':'','city':'','state':'','zipcode':'','country':'','phonetype':'','phone':''};
			var ftype = fieldtype.toString().toLowerCase();
			return isD( contactInfo[ftype] ) ? contactInfo[ftype] : "";
		};

		s.deleteSignUp = function(){
			if(s.previewOnly )
				return;
			var delUrl = "/index.cfm?go=s.DeletePerson&id=" + s.signup.id;
			if( s.anonymous )
				delUrl += "&token=" + s.attrs.token;
			else if( s.user.loggedin && s.objForm.imid > 0 )
				delUrl += "&imid=" + s.objForm.imid + "&mid=" + s.user.memberid;

			else
				return; // not sure about this scenario yet

			// redirect to the delete page - at some point we'll need to refactor the delete to use a reusable method
			win.location.href = delUrl;
		};

		s.goBackTo = function(){
			if(s.previewOnly )
				return;

			if( s.showreturntosulink ){
				var url = s.backtosignupLink.indexOf('http') == -1 ? "http://" + s.backtosignupLink : s.backtosignupLink;

				var alertWindow = modal.open({
					templateUrl : '/view/templates/signups/form/backtowebsiteconfirm.html',
					controller : 'backToWebsiteController',
					resolve : {
						redirect : function(){
							return url;
						}
					}
				});

				alertWindow.result.then(
					function(){
						win.location.href = url;
					});
			}
			else {
				if (s.useSinglePageApplication) {
					// When using the SPA, return user to base route
					location.path("/");
				} else {
					win.location.href = s.winorigin + s.backtosignupLink;
				}
			}

			// set/recycle ads
			if( s.showsegments && typeof deployads !== 'undefined' ){
				setTimeout( function(){
					deployads.push();
				}, 500);
			}

		};

		/** helper method to check if item can be deleted **/
		s.canDelete = function(){
			if( s.isrsvp )
				return false;

			if( s.anonymous )
				return ( !s.hasPayItems || (s.hasPayItems && !s.hasPaid ) );
			else
				return ( s.hasPayItems && s.paymentIsPending && !s.hasPaid );
		};

		/** helper method for converting values to float **/
		var toFloat = function( val ){
			return typeof val !== "undefined" && val !== "" ? parseFloat( parseFloat(val.toString().replace(',','')).toFixed(2) ) : 0.00;
		};

		/** helper method for lower casing strings **/
		var lowerCaseIt = function( str ){
			return str.toString().toLowerCase().trim();
		};

		/** helper method for checking if a variable or key is defined **/
		var isD = function( key ){
			return angular.isDefined( key );
		};

		/** helper method for creating an input element **/
		var createInput = function( type, name, value ){
			var input = document.createElement('input');
				input.type = type;
				input.name = name;
				input.value = value;
			return input;
		};

		/** sign up process response handler **/
		var processSignUpHander = function( resp ){

			/**
			* shared private method for processing completed sign up - this controls presentation of the thank you page
			* @param extendedattrs - extendedattributes object for rokt ads, passed through only on wepay signups
			**/
			var showThankYou = function(extendedattrs){
				// Fix the missing extendedattributes in the response from the updated wepay workflow
				if (isD(extendedattrs) && !isD(resp.extendedattributes)) {
					resp.extendedattributes = extendedattrs;
				}

				s.complete = true;
				s.containerWidth = win.innerWidth;
				if( s.containerWidth > 1199 )
					s.hAdWidth = 330;

				s.isProcessing = false;
				s.complete = true;
				s.name = s.objForm.displayfirstname !== '' ? s.objForm.displayfirstname : s.objForm.firstname;
				s.memberid = isD(resp.memberid) ? resp.memberid : 0;
				s.confirmationsent = s.memberid > 0;
				s.showCalendar = (s.memberid > 0 && !s.nodatesignup);
				s.calLinks = isD(resp.icals) ? resp.icals : {};
				s.slotids = '';
				s.listid = s.signup.id;
				s.signupowner = s.signup.owner;
				s.signupcontact = s.signup.contactname;
				s.isfullmember = isD(resp.fullmember) ? resp.fullmember : ( s.user.loggedin ? true : false );
				// defaults
				s.ty = {
					"response": "You're all singed up for "
				};

				// if there is a retargeting script
				if( isD(resp.retargetingscripts) && resp.retargetingscripts !== '' ){
					document.getElementById("retargeting").innerHTML = '';
					document.getElementById("retargeting").innerHTML = resp.retargetingscripts;
				}

				if( s.isrsvp ){
					// rsvp sign up
					s.attending = false;
					s.showrsvpguests = false;
					s.guestString = '';
					s.slotids = resp.slotid;
					var myresp = lowerCaseIt(s.objForm.rsvpresponse);
					if( myresp === 'y' )
						s.ty.response = "You have responded 'Yes' to ";
					else if( myresp === 'n' )
						s.ty.response = "You have responded 'No' to ";
					else if( myresp === 'm' )
						s.ty.response = "You have responded 'Maybe' to ";

					if( myresp === 'm' || myresp === 'y' ){
						s.attending = true;
						s.showrsvpguests = true;
						if( s.signup.childrsvp == 1 ){
							var adultString = parseInt(s.objForm.rsvpadult) > 1 ? 'Adults' : 'Adult';
							s.guestString += '(' + s.objForm.rsvpadult + ') ' + adultString + ', ' + '(' + s.objForm.rsvpchildren + ') Children';
						}
						else {
							s.guestString += '(' + s.objForm.rsvpadult + ')';
						}
					}

					// build rsvp date/time
					s.editrsvplink = "/index.cfm?go=s.PreProcessSignup&urlid=" + s.signup.urlid + "&RSVPid=" + resp.rsvpid + "&ref=" + s.h;
					if( s.anonymous )
						s.editrsvplink += "&token=" + s.attrs.token;
					s.rsvpitems = isD( resp.rsvpitems ) && angular.isArray( resp.rsvpitems ) ? resp.rsvpitems : [];
					s.haslocation = (isD(s.rsvpdetails.location) && s.rsvpdetails.location !== '');
					s.rsvplocation = s.haslocation ? s.rsvpdetails.location.toString().trim() : "";
					s.rsvpdatetime = "";
					if( s.rsvpdetails.starttime !== '' ){
						try {
							s.rsvpdetails.dtstarttime = new Date( s.rsvpdetails.starttime );
							s.rsvpdetails.dtstarttime = Date.parse( s.rsvpdetails.dtstarttime );
							s.rsvpdatetime += " " + filter('date')(s.rsvpdetails.dtstarttime, 'EEE') + '., ' + filter('date')(s.rsvpdetails.dtstarttime, s.dateformat );
							if( s.rsvpdetails.usetime ){
								var hdrPronouns = s.rsvpdetails.endtime === '' ? " at " : " from ";
								s.rsvpdatetime += hdrPronouns + (filter('date')(s.rsvpdetails.dtstarttime, 'h:mma' )).toLowerCase();
							}
						} catch( e ){}
					}
					if( s.rsvpdetails.endtime !== '' ){
						try {
							s.rsvpdetails.dtendtime = new Date( s.rsvpdetails.endtime );
							s.rsvpdetails.dtendtime = Date.parse( s.rsvpdetails.dtendtime );
							if( s.rsvpdetails.usetime )
								s.rsvpdatetime += ' - ' + (filter('date')(s.rsvpdetails.dtendtime, 'h:mma' )).toLowerCase();

						} catch( e ){}
					}

					s.rsvpdatetime = s.rsvpdatetime.trim();
					if( s.rsvpdetails.usetime )
						s.rsvpdatetime += " " + s.shortZone;


					// ROKT
					if(resp.extendedattributes) {
						// Display Rokt Ad
						if (resp.extendedattributes.email){
							adService.initRoktSnippet(resp.extendedattributes);
							adService.initAdsPostXSnippet(resp.extendedattributes);
							s.hideBannerAdsForRokt = true; // set this to true moving forward
						}
						// Hide Banner Ads
						// SUG-6585: Turning this off for now - per the requirements, it needs to be so that it can be renabled if needed
						/*
						if (resp.extendedattributes.page_experience && resp.extendedattributes.page_experience.indexOf("split_segment_off_") > -1){
							s.hideBannerAdsForRokt = true;
						}
						*/
					}

				}
				else {
					// standard sign up
					var gc = isD(s.calLinks.google) ? s.calLinks.google : {};
					var temp = {};
					s.slotids = [];
					for( var i in resp.items )
						s.slotids.push( resp.items[i].slotid );
					s.slotids = s.slotids.toString();
					s.myitems = [];
					angular.forEach( resp.items, function(obj,key){
						temp = {};
						temp.item = obj.item;
						temp.itemhelp = obj.itemcomment;
						temp.myqty = obj.myqty;
						temp.mycomment = obj.mycomment;
						temp.slotid = obj.slotid;
						temp.slotitemid = obj.slotitemid;
						temp.itemmemberid = obj.itemmemberid;
						temp.location = obj.location;
						temp.slotdatestring = '';
						try {
							temp.slotdatestring = filter('date')(obj.dtstarttime, 'EEE') + '., ' + filter('date')(obj.dtstarttime, s.dateformat );
							if( obj.usetime === 1 )
								temp.slotdatestring += ' ' + (filter('date')(obj.dtstarttime, 'h:mma' )).toLowerCase();
						} catch( e ){}
						if( obj.usetime === 1 && obj.dtendtime !== '' && obj.dtendtime !== obj.dtstarttime ){
							try {
								temp.slotdatestring += ' - ' + (filter('date')(obj.dtendtime, 'h:mma' )).toLowerCase();
							} catch( e ){}
						}
						if( temp.slotdatestring !== '' && obj.usetime === 1 )
							temp.slotdatestring += ' ' + s.shortZone;
						// trim it just in case
						temp.slotdatestring =  temp.slotdatestring.trim();
						temp.callink = obj.slotid in gc ? gc[obj.slotid] : '';
						s.myitems.push( temp );
					});

					if( s.myitems.length == 1 ){
						s.editsignuplink = "/index.cfm?go=s.PreProcessSignup&urlid=" + s.signup.urlid + "&siid=" + s.myitems[0].slotitemid + "&imid=" + s.myitems[0].itemmemberid + "&ref=" + s.h;
						if( s.anonymous )
							s.editsignuplink += "&token=" + s.attrs.token;
					}


					// ROKT
					if(resp.extendedattributes) {
						// Display Rokt Ad
						if (resp.extendedattributes.email){
							adService.initRoktSnippet(resp.extendedattributes);
							adService.initAdsPostXSnippet(resp.extendedattributes);
							s.hideBannerAdsForRokt = true; // set this to true moving forward
						}
						// Hide Banner Ads
						// SUG-6585: Turning this method into a private function to disable it - per the requirements, it needs to be so that it can be renabled if needed
						/*
						if (resp.extendedattributes.page_experience && resp.extendedattributes.page_experience.indexOf("split_segment_off_") > -1){
							s.hideBannerAdsForRokt = true;
						}
						*/
					}

				}

				// set/recycle ads
				if( s.showsegments && typeof deployads !== 'undefined' ){
					setTimeout( function(){
						deployads.push();
					}, 500);
				}

				// scroll to top
				win.scrollTo( 0, 0 );
			};

			// helper method for removing incomplete sign up process - typically happens when a payment is cancelled or times out.
			var removeSignupTransaction = function(){

				// we should not delete the item when on edit mode
				if( s.editmode )
					return;

				s.complete = false;
				var arrItems = isD( resp.items ) ? resp.items : s.items;
				var data = {}; // get checkoutid, itemmemberids, siids
				var paymentConfig = {};
				if (typeof resp.wepay !== 'undefined') {
					paymentConfig = resp.wepay;
					data.signuppaymentid = paymentConfig.signuppaymentid;
				} else if  (typeof resp.lumapay !== 'undefined') {
					paymentConfig = resp.lumapay;
					data.signuppaymentid = paymentConfig.signuppaymentid;
				}
				data.listid = isD( resp.listid ) ? resp.listid : s.signup.id;
				data.imid = [];
				// retrieve the itemmberids
				angular.forEach( arrItems, function(obj,key){
					if( isD(obj.itemmemberid) )
						data.imid.push( obj.itemmemberid );
				});

				svc.removeSignupTransaction( data )
					.then( function( response ){
						var r = util.lowerCaseKeys( response );
						if( !resultCheck( r.data ) ){
							errorHandler( r.data );
						}
						else {
							// everything is removed. do nothing at this point.
						}
					});
			};

			/**
			 *  Helper method to complete the WePay payment sign up transaction
			 * @param wePayModal {uibModal} - modal instance for the WePay checkout
			 * @param wepay - wepay return obejct from completeWePayPayment call
			 * @param extendedattrs - extendedattributes return object fromcompleteWePayPayment call
			 * */
			s.completeWePaySignUp = function( wePayModal, wepay, extendedattrs ){

				var arrItems = isD( resp.items ) ? resp.items : s.items;
				var data = {}; // get checkoutid, itemmemberids, siids
					data.signuppaymentid = wepay.signuppaymentid;
					data.listid = isD( resp.listid ) ? resp.listid : s.signup.id;
					data.imid = [];


				// retrieve the itemmberids
				angular.forEach( arrItems, function(obj,key){
					if( isD(obj.itemmemberid) )
						data.imid.push( obj.itemmemberid );
				});

				svc.completeSignupTransaction( data )
					.then( function( response ){
						var r = util.lowerCaseKeys( response );
						if( !resultCheck( r.data ) ){
							wePayModal.close({success:false});
							errorHandler( r.data );
						}else{
							wePayModal.close({success:true});
							showThankYou(extendedattrs);
						}
					});
			};

			/**
			 *  Helper method to complete the LumaPay payment sign up transaction
			 * @param LumaPayModal {uibModal} - modal instance for the LumaPay checkout
			 * @param lumapay - LumaPay return obejct from completeLumaPayPayment call
			 * @param extendedattrs - extendedattributes return object from completeLumaPayPayment call
			 * */
			 s.completeLumaPaySignUp = function( LumaPayModal, lumapay, extendedattrs ){

				var arrItems = isD( resp.items ) ? resp.items : s.items;
				var data = {}; // get checkoutid, itemmemberids, siids
					data.signuppaymentid = lumapay.signuppaymentid;
					data.listid = isD( resp.listid ) ? resp.listid : s.signup.id;
					data.imid = [];


				// retrieve the itemmberids
				angular.forEach( arrItems, function(obj,key){
					if( isD(obj.itemmemberid) )
						data.imid.push( obj.itemmemberid );
				});

				svc.completeSignupTransaction( data )
					.then( function( response ){
						var r = util.lowerCaseKeys( response );
						if( !resultCheck( r.data ) ){
							LumaPayModal.close({success:false});
							errorHandler( r.data );
						}else{
							LumaPayModal.close({success:true});
							showThankYou(extendedattrs);
						}
					}).catch(function(err){					
						LumaPayModal.close({success:false});
						errorHandler(err);
						console.err(err);					
					});
			};

			/**
			 *  Helper method to complete the WePay payment
			 * @param payload - payload returned from the wepay modal containing the credit_card_id needed to complete the checkout process
			 * @param wePayMoal {uibModal} - modal instance for the WePay checkout
			 * */
			s.completeWePayPayment = function (payload, wePayModal) {
				var data = {};
				data.iFrameConfig = payload;
				svc.completeWePayPayment( data )
				.then( function( response ){
					var r = util.lowerCaseKeys( response );
					if( !resultCheck( r.data ) ){
						// Failed checkout attempt.
						// Dismiss modal to prevent infinite spinner that prevents user from closing modal
						wePayModal.dismiss();
						util.showMagnificAlert( 'This sign up cannot process payments at this time. <a href="/index.cfm?go=c.help&mid=' + s.signup.owner + '&id=' + s.signup.id + '">Please contact the sign up creator</a>.');
					}else{
						// Set the resposne wepay object to a variable so it easily passed into the completeWePaySignUp call
						var wepay = r.data.data.wepay;
						var extendedattrs = r.data.data.extendedattributes;
						s.completeWePaySignUp(wePayModal, wepay, extendedattrs);
					}
				});
			};

			/**
			 *  Helper method to complete the LumaPay payment
			 * @param payload - payload returned from the lumaPay modal needed to complete the checkout process
			 * @param lumaPayModal {uibModal} - modal instance for the lumaPay checkout
			 * */
			 s.completeLumaPayPayment = function (payload, lumaPayModal) {
				var data = {};
				data.paymentConfig = payload;
				svc.completeLumaPayPayment( data )
				.then( function( response ){
					var r = util.lowerCaseKeys( response );
					if( !resultCheck( r.data ) ){
						// Failed checkout attempt.
						// Dismiss modal to prevent infinite spinner that prevents user from closing modal
						lumaPayModal.dismiss();
						errorHandler( r.data );
					}else{
						// Set the response lumapay object to a variable so it easily passed into the completeLumaPaySignUp call
						var lumapay = r.data.data.lumapay;
						var extendedattrs = r.data.data.extendedattributes;
						s.completeLumaPaySignUp(lumaPayModal, lumapay, extendedattrs);
					}
				}).catch(function(err){					
					// Failed checkout attempt.
					// Dismiss modal to prevent infinite spinner that prevents user from closing modal
					lumaPayModal.dismiss();
					errorHandler( err );
					console.err(err);					
				});
			};

			// LumaPay checkout
			if( isD(resp.dopayment) && resp.dopayment && isD(resp.lumapay) ){
				var payload = resp.lumapay;
				// Set payload fields for populating form in iframe
				payload.nameOnCard = payload.payerinfo.name;
				payload.email = payload.payerinfo.email;
				payload.zip = payload.payerinfo.address.postal_code.replace('$strip$_','');
				payload.amount = payload.amount;
				payload.serviceFee = payload.fee_payer == "payer_from_app" ? 1 : 0;
				payload.stripeapikey = globalJSService.lumapay.sugpublickey;
				payload.stripeapiversion = globalJSService.lumapay.APIVersion;

				// Set LumaPay variables for pass through in scope
				s.environment = globalJSService.secureURL;
				// Fix environment value for staging environment so desktop checkout modal will load correctly
				if (s.environment == 'https://www.signupgenius.com' && win.location.hostname == 'staging.signupgenius.com') {
					s.environment = 'https://staging.signupgenius.com';
				}

				modal.open({
					backdrop: 'static',
					keyboard: false,
					templateUrl: '/view/tools/dsplumapaymodal.html?v=1617022515',
					controller: 'lumaPayModalController',
					resolve: {
						payload: function () {
							return payload;
						},
						mainScope: function(){
							return s; // pass it - don't reach it.
						}
					}
				})
				.result.then(function (r) {
					// closed / complete
					s.isProcessing = false;
					if( !r.success )
						removeSignupTransaction();

				}, function(r) {
					// x button
					s.isProcessing = false;
					if( typeof r != 'undefined' && !r.success )
						removeSignupTransaction();
				});
			}
			// WePay checkout
			else if( isD(resp.dopayment) && resp.dopayment && isD(resp.wepay) ){
				var payload = resp.wepay;
				// Set payload fields for populating form in iframe
				payload.nameOnCard = payload.payerinfo.name;
				payload.email = payload.payerinfo.email;
				payload.zip = payload.payerinfo.address.postal_code.replace('$strip$_','');
				payload.amount = payload.amount;
				payload.serviceFee = payload.fee_payer == "payer_from_app" ? 1 : 0;
				// Set WePay variables for pass through in scope
				s.wepayclientid = globalJSService.wepayclientid;
				s.wepayendpoint = globalJSService.oauthenvironment;
				s.environment = globalJSService.secureURL;
				// Fix environment value for staging environment so desktop checkout modal will load correctly
				if (s.environment == 'https://www.signupgenius.com' && win.location.hostname == 'staging.signupgenius.com') {
					s.environment = 'https://staging.signupgenius.com';
				}


				modal.open({
					backdrop: 'static',
					keyboard: false,
					templateUrl: '/view/tools/dspwepaymodal.html?v=1617022515',
					controller: 'wePayModalController',
					resolve: {
						payload: function () {
							return payload;
						},
						mainScope: function(){
							return s; // pass it - don't reach it.
						}
					}
				})
				.result.then(function (r) {
					// closed / complete
					s.isProcessing = false;
					if( !r.success )
						removeSignupTransaction();

				}, function(r) {
					// x button
					s.isProcessing = false;
					if( typeof r != 'undefined' && !r.success )
						removeSignupTransaction();
				});
			}
			else if( isD(resp.dopayment) && resp.dopayment && isD(resp.pobj) ){ // PayPal
				var input = '';
				var pobj = resp.pobj;
				var pdata = pobj.pp_data;
				var sanbox = pdata.sandbox.toString().trim();
				/** create basic form structure **/
				var pp_form = document.createElement('FORM');
					pp_form.id = 'paypal';
					pp_form.name = '_xclick';
					pp_form.method = 'POST';
					pp_form.action = 'https://www' + sanbox + '.paypal.com/cgi-bin/webscr';
					if( sanbox !== '' ){
						input = createInput('hidden','test_ipn','1');
						pp_form.appendChild( input );
					}
					input = createInput('hidden','cmd','_cart');
					pp_form.appendChild( input );
					input = createInput('hidden','upload','1');
					pp_form.appendChild( input );
					input = createInput('hidden','business',pobj.paypalemailaddress);
					pp_form.appendChild( input );
					input = createInput('hidden','currency_code',pdata.currency_code);
					pp_form.appendChild( input );
					input = createInput('hidden','solutiontype','Sole');
					pp_form.appendChild( input );
					input = createInput('hidden','custom',pdata.custom);
					pp_form.appendChild( input );
					input = createInput('hidden','cancel_return',pdata.cancel_return);
					pp_form.appendChild( input );
					input = createInput('hidden','return',pdata['return']);
					pp_form.appendChild( input );
					input = createInput('hidden','notify_url',pdata.notify_url);
					pp_form.appendChild( input );
					input = createInput('hidden','cbt',pdata.cbt);
					pp_form.appendChild( input );

				/** create member inputs **/
				if( isD(pobj.member) ){
					var m = pobj.member;
					var arrKeys = ['first_name','last_name','address1','address2','city','state','zip','night_phone_a','night_phone_b','night_phone_c','email','bn'];
					angular.forEach( arrKeys, function(obj,key){
						if( obj in m ){
							input = createInput('hidden',obj,m[obj]);
							pp_form.appendChild( input );
						}
					});
				}

				/** create item inputs **/
				var items = isD(pobj.pp_data.items) ? pobj.pp_data.items : []; // shouldn't be empty.
				angular.forEach( items, function(item,key){
					for( var k in item ){
						input = createInput('hidden',k,item[k]);
						pp_form.appendChild( input );
					}
				});

				// submit form
				document.body.appendChild(pp_form);
				pp_form.submit();
				// s.isProcessing = false;

			}
			else {
				// no payment stuff
				showThankYou();
			}

		};



		/** helper method for retrieving item name by slotitemid **/
		var lookupItemBySlotItemID = function( siid ){
			for( var i in s.items ){
				if( s.items[i].slotitemid === siid ){
					return s.items[i].item;
				}
			}
		};

		/** helper method for retrieving item id by slotitemid **/
		var lookupItemIdBySlotItemID = function( siid ){
			for( var i in s.items ){
				if( s.items[i].slotitemid === siid ){
					return s.items[i].itemid;
				}
			}
		};

		var getItemBySlotItemID = function( siid ){
			for( var i in s.items ){
				if( s.items[i].slotitemid === siid ){
					return s.items[i];
				}
			}
		};

		var qtyLookupBySlotItemID = function( siid ){
			for( var i in s.items ){
				if( s.items[i].slotitemid === siid ){
					return s.items[i].qty;
				}
			}
		};

		var getUnfilledRSVPItems = function(){
			 var retItems = [];
			// let's loop through the available items and their quantities and what is applicable to be shown
			angular.forEach( s.items, function(obj,key){
				if( obj.availableqty > 0 )
					retItems.push( obj );
			});

			return retItems;
		};

		/** helper method for items **/
		var itemHandler = function(){

			/** if applicable, loop through items and restructure for output **/
			angular.forEach(s.items, function(obj,key){
				var _thisptype = '';
				var _thisoptions = [];
				var _thisprices = [];
				var moddate = new Date();
				obj.itemname = sce.trustAsHtml( obj.item.toString() );
				if( !isD(obj.myqty) )
					obj.myqty = 0;
				if( !isD(obj.mycomment) )
					obj.mycomment = '';
				obj.mydonation = '';
				obj.priceError = false;
				obj.commentError = false;
				obj.slotError = false;
				obj.paymentAmount = 0;
				obj.paymentOptions = [];
				obj.paymentOptionSelected = {};
				obj.dtstarttime = '';
				obj.dtendtime = '';

				// can show product image if signup is wepay or lumapay or owner has the product images feature; not allowed for rsvp sign ups
				if( !s.showproductimage && ( (s.signupiswepay || s.signupislumapay) || typeof s.signup.productimages !== 'undefined' && s.signup.productimages ) && !s.isrsvp )
					s.showproductimage = (obj.itemimage.toString().trim() !== '');	// s.signup.productimages
				if(obj.starttime !== ''){
					try {
						obj.dtstarttime = new Date( obj.starttime );
						obj.dtstarttime = Date.parse( obj.dtstarttime );

						if( !s.isrsvp && s.editmode){
							if( s.signup.closedateutc !== '' && s.closeLock > 0  && !s.editLocked ){	//Sign Up Start / Stop Dates
								var lockdatetime = new Date( s.signup.closedateutc );
								s.editLocked = ( lockdatetime < moddate );
							}

							if( s.modifyLock > 0 && !s.editLocked){			//Sign Up Locking
								var eventStartTime = new Date( obj.starttime );
									moddate.setDate( moddate.getDate() + s.modifyLock );
								s.editLocked = (moddate > eventStartTime);
							}
						}

					} catch( e ){}
				}
				if( obj.endtime !== '' ){
					try {
						obj.dtendtime = new Date( obj.endtime );
						obj.dtendtime = Date.parse( obj.dtendtime );
					} catch( e ){}
				}

				_thisptype = obj.paymenttype.toString().toLowerCase();
				if( s.arrpaytypes.indexOf( _thisptype ) >= 0 ){
					s.hasPayItems = true;

					if( obj.paymentrequired === 1 )
						s.paymentRequired = true;

					if( _thisptype === 'options' && isD(obj.optionnamelist) && isD(obj.optionpricelist) ){
						_thisoptions = obj.optionnamelist.split(',');
						// make encoded commas readable
						for(var oidx=0;oidx<_thisoptions.length;oidx++){
							if(_thisoptions[oidx].toString().length){
								_thisoptions[oidx] = _thisoptions[oidx].toString().replace(new RegExp('&#44;','g'),',');
							}
						}
						_thisprices = obj.optionpricelist.split(',');
						angular.forEach( _thisoptions, function( opt, key){
							obj.paymentOptions.push({value:_thisprices[key],label:opt});
						});
						if( s.editmode && obj.optionselected !== '' )
							obj.paymentOptionSelected = obj.paymentOptions[ parseInt(obj.optionselected) - 1 ];
					}
					else if( _thisptype === 'noset' && !s.editmode && (obj.price === '' || obj.price === 0) ){
						obj.price = isD(obj.minimumamount) ? toFloat(obj.minimumamount).toFixed(2) : 0.00;
					}

					if( s.editmode ){
						s.hasPaid = s.hasPaidStatus.indexOf( obj.status.toString().trim().toLowerCase() ) >= 0 ? true : false;
						s.paymentIsPending = obj.status.toString().toLowerCase().indexOf('pending') >= 0 ? true : false;
						if( _thisptype === 'noset' && angular.isNumber(obj.amountpaid) && (!angular.isNumber(obj.price) || obj.price === 0) && angular.isNumber(obj.myqty) )
							obj.price = obj.amountpaid / obj.myqty;
					}
				}

				if( s.editmode && s.user.loggedin && !s.isrsvp ){
					var dfn = obj.displayfirstname.toString().trim();
					var dln = obj.displaylastname.toString().trim();
					var sfn = s.user.firstname.toString().trim();
					var sln = s.user.lastname.toString().trim();
					if( dfn !== '' && ( sfn != dfn || sln != dln ) ){
						s.objForm.usealternatename = true;
						s.objForm.displayfirstname = obj.displayfirstname;
						s.objForm.displaylastname = obj.displaylastname;
					}
				}
				if( s.editmode && !s.user.loggedin && s.anonymous && !s.isrsvp){
					s.objForm.displayfirstname = obj.displayfirstname;
					s.objForm.displaylastname = obj.displaylastname;
					s.objForm.firstname = obj.displayfirstname;
					s.objForm.lastname = obj.displaylastname;
					s.objForm.email = obj.email;
				}

				if( !s.isrsvp ){
					obj.availableqty = obj.myqty + obj.availableqty;
					if( obj.myqty === 0 || obj.myqty === '' || obj.myqty === null && obj.availableqty > 0 )
						obj.myqty = 1;
					if( s.qtyLimitEnabled ){
						if( s.itemQtyLimit > 0 )
							obj.availableqty = ( s.itemQtyLimit < obj.availableqty ) ? s.itemQtyLimit : obj.availableqty;
						else if( s.signupQtyLimit > 0 )
							obj.availableqty = ( s.signupQtyLimit < obj.availableqty ) ? s.signupQtyLimit : obj.availableqty;
					}
				}

				// pre-process discount information
				// set default values
				obj.discountisavailable = false;
				obj.discountlabel = "";

				// if date based discount
				if( obj.discounttype == 'D' ){
					// if expiration date in the future
					var currentDate = new Date();
					//convert db date into js date - db format is like {d '2018-01-31'}
					var temp = obj.discountcriteria.replace(/[{d' }]/g,"").split(/[- :]/);
					var expirationDate = new Date(temp[0], temp[1]-1, temp[2], "23", "59", "59");

					// if discount meets date criteria
					if( typeof expirationDate.getTime() === 'number' && !isNaN(expirationDate.getTime()) && expirationDate >= currentDate ){
						obj.discountisavailable = true;
						obj.discountlabel = "Discount: " + $filter('currency')( obj.discountprice );	// + ' ' + s.signup.currency;
						obj.discountlabel += " until " + $filter('date')(expirationDate,'MM/dd/yyyy');
					}
				}
				// if quantity based discount - has no date expiration
				if( obj.discounttype == 'Q' ){
					obj.discountisavailable = true;
					obj.discountlabel = "Discount: " + $filter('currency')( obj.discountprice );	// + ' ' + s.signup.currency;
					obj.discountlabel += " for " + obj.discountcriteria + " or more";
				}

				// let's get the available quantity here - only applicable to items that are not unlimited
				if( obj.qty > 1 && obj.qty < 999999 ){
					obj.dropdownqty = s.getQtyArray( obj.availableqty );
				}

			});

			if( s.hasPayItems ){
				// if sign up has payment and the creator does not have wepay or paypal
				s.disablesignup = (!s.signup.ispp && !s.signup.iswp && !s.signup.islp);

				if( s.disablesignup ){
					s.signupLoaded = false;
					s.errormessage = 'This sign up cannot process items which require payments at this time. Please <a href="/index.cfm?go=c.help&mid=' + s.signup.owner + '&id=' + s.signup.id + '">contact the sign up creator</a>.';
					return;
				}

				s.tbodyColCt = s.nodatesignup ? 4 : 5;
				s.labels.submitBtn = "Sign Up & Pay Now";
				if( s.editmode ){
					if( s.paymentIsPending ){
						s.labels.submitBtn = !s.hasPaid ? "Update & Retry Payment" : "Update My Sign Up";
					} else {
						s.labels.submitBtn = !s.hasPaid ? "Update & Pay Now" : "Update My Sign Up";
					}
					s.labels.payLater = "Update & Pay Later";
				}
			}

			if( s.hasPayItems ){
				s.tbodyColCt = s.nodatesignup ? 4 : 5;
				if( s.showproductimage )
					s.tbodyColCt++;
				s.labels.submitBtn = "Sign Up & Pay Now";
				if( s.editmode ){
					if( s.paymentIsPending ){
						s.labels.submitBtn = !s.hasPaid ? "Update & Retry Payment" : "Update My Sign Up";
					} else {
						s.labels.submitBtn = !s.hasPaid ? "Update & Pay Now" : "Update My Sign Up";
					}
					s.labels.payLater = "Update & Pay Later";
				}
				// Force price and minimumprice to display 2 decimal points when page loads.
				s.setPriceTwoDecimals();
			}

			// calculate initial line prices and grand total
			if( !s.isrsvp && s.items.length )
				s.calculateLinePrice();

			if( !s.isrsvp && !s.items.length ){
				s.asyncSuccess = false;
				util.showMagnificAlert('The item(s) you are signing up for are no longer available.');
			}

			// load the select picker
			// refreshSelectPicker();
		};

		/** helper method for custom questions - we will separate the address and phone from the custom fields array to make it cleaner **/
		var customQuestionHander = function(){
			s.addressRequired = false;
			s.phoneRequired = false;
			s.canadianStates = [];
			s.usStates = [];
			// create a deep copy
			angular.copy(s.signup.customfields , s.customFields);
			var i = s.customFields.length - 1;
			var type = '';
			var address = ['address1','address2','city','state','zipcode','country'];
			var phone = ['phone','phonetype'];
			var fieldtype = '';
			var fieldvalues = '';
			var temp = {};
			var thisval = '';
			var newitem = true;
			var cq = 0;
			for( i; i >= 0; i-- ){
				type = s.customFields[i].fieldname.toString().toLowerCase();
				fieldtype = s.customFields[i].fieldtype.toString().toLowerCase();
				fieldvalues = s.customFields[i].fieldvalues;

				if( address.indexOf(type) !== -1 ){
					if( type === 'address1' && s.customFields[i].required )
						s.addressRequired = true;

					s.customFields[i].fieldorder = address.indexOf(type);
					s.cq_address.unshift( s.customFields[i] );
					s.customFields.splice(i,1);
				}
				else if( phone.indexOf(type) !== -1 ){
					if( type === 'phone' ){
						s.customFields[i].fieldtype = 'Text';
						s.phoneRequired = s.customFields[i].required;
					}
					else if( type === 'phonetype' ){
						s.customFields[i].fieldtype = 'Select';
					}
					s.customFields[i].fieldorder = phone.indexOf(type);
					s.cq_phone.unshift( s.customFields[i] );
					s.customFields.splice(i,1);
				}
			}

			if( s.cq_address.length ){
				angular.forEach( s.cq_address, function(obj,key){
					thisval = isD(obj.myvalue) ? obj.myvalue.toString().trim() : "";
					newitem = isD(obj.customdataid) && parseInt(obj.customdataid) > 0 ? false : true;
					if( thisval === '' && !s.editmode && newitem ){
						obj.myvalue = s.getContactInfoValue( obj.fieldtype );
					}
					if( lowerCaseIt(obj.fieldname) === 'state' ){
						s.selectedState = thisval;
						angular.forEach( obj.fieldvalues, function(o,k){
							if( isD(o.countryid) && o.countryid !== '' && parseInt(o.countryid) > 0 ){
								if( o.countryid == 223 )
									s.usStates.push( o.optionval );
								else if( o.countryid == 37 )
									s.canadianStates.push( o.optionval );
							}
						});
						s.states = obj.fieldvalues;
					}
					if( lowerCaseIt(obj.fieldname) === 'country' ){
						s.selectedCountry = thisval;
						s.filterStates();
					}
				});

			}

			if( s.cq_phone.length ){
				angular.forEach( s.cq_phone, function(obj,key){
					thisval = isD(obj.myvalue) ? obj.myvalue.toString().trim() : "";
					newitem = isD(obj.customdataid) && parseInt(obj.customdataid) > 0 ? false : true;
					if( thisval === '' && newitem ){
						obj.myvalue = s.getContactInfoValue( obj.fieldname );
						if( obj.myvalue === '' && lowerCaseIt(obj.fieldname) === 'phonetype' )
							obj.myvalue = 'Mobile';
					}
				});
			}
		};

		/** helper method for updating top navigation menu **/
		var updateMenu = function(){
			svc.getMainNavigation()
				.then( function(response){
					var r = util.lowerCaseKeys( response );
					if( !resultCheck( r.data ) ){
						errorHandler( r.data );
					}
					else {
						var menu = angular.element( document.querySelector( '#main-nav' ) );
							menu.empty(); // remove existing menu
							menu.append( r.data.data ); // append the new menu
					}
				});
		};

		/** custom questions validations **/
		var validateCustomFields = function(){
			var reqkeyes = [];
			var addressPopulated = true;
			var phonePopulated = true;
			var stateValue = '';
			var thisValue = '';
			// address
			if( s.cq_address.length ){
				reqkeyes = ['address1','city','state','zipcode'];
				angular.forEach( s.cq_address, function(obj,key){
					thisValue = obj.myvalue !== null ? obj.myvalue.toString().trim() : '';
					if( reqkeyes.indexOf( lowerCaseIt(obj.fieldname) ) !== -1 ){
						// if value is null
						if( thisValue === '' ){
							addressPopulated = false;
							if( s.addressRequired ){
								s.errorMessages[obj.id] = '';
								s.success = false;
								if( lowerCaseIt(obj.fieldname) === 'state' || lowerCaseIt(obj.fieldname) === 'zipcode' )
									s.errorMessages.state_zip = true;
							}

						}
						else if( lowerCaseIt(obj.fieldname) === 'state' && thisValue == 'NA' && s.addressRequired && (s.selectedCountry == 37 || s.selectedCountry == 223) ){
							addressPopulated = false;
							s.errorMessages.state_zip = true;
							s.errorMessages[obj.id] = 'You must select a valid Sate.';
							s.success = false;
						}
					}
				});
			}

			// phone
			if( s.cq_phone.length ){
				reqkeyes = ['phone','phonetype'];
				angular.forEach( s.cq_phone, function(obj,key){
					if( reqkeyes.indexOf( lowerCaseIt(obj.fieldname) ) !== -1 ){
						if( obj.myvalue !== null && obj.myvalue.toString().trim() === '' ){
							if( s.phoneRequired ){
								s.errorMessages.phone = '';
								s.errorMessages[obj.id] = '';
								s.success = false;
							}
							phonePopulated = false;
						}
						/* removing phone validation for now
						else if( lowerCaseIt(obj.fieldname) === 'phone' && obj.myvalue !== '' && !util.validatePhone( obj.myvalue ) ){
							s.errorMessages.phone = '';
							s.errorMessages[obj.id] = 'The phone number you entered is invalid.';
							s.success = false;
							phonePopulated = false;
						}
						*/
					}
				});
			}

			if( s.objForm.savecontactinfo && !s.phoneRequired && !phonePopulated ){
				s.errorMessages.savecontactinfo = s.standardErrors.savecontactinfo;
				s.success = false;
			}

			// others
			if( s.customFields.length ){
				var ftype, myvalue = '';
				var minlen, maxlen = 0;
				var matched = false;
				angular.forEach( s.customFields, function(obj,key){
					ftype = lowerCaseIt(obj.fieldtype);
					minlen = angular.isNumber(obj.minval) ? parseInt(obj.minval) : 0;
					maxlen = angular.isNumber(obj.maxval) ? parseInt(obj.maxval) : 0;
					if( ftype === 'text' ){ // text validations
						myvalue = angular.isDefined(obj.myvalue) && obj.myvalue !== null ? obj.myvalue.toString().trim() : '';
						if( obj.required && myvalue === '' )
							s.errorMessages[obj.id] = '';
						else if( minlen > 0 && myvalue.length < minlen )
							s.errorMessages[obj.id] = 'Your response must be at least ' + minlen + ' characters.';
						else if( maxlen > 0 && myvalue.length > maxlen )
							s.errorMessages[obj.id] = 'Your response must not exceed ' + maxlen + ' characters.';
					}
					else if( ftype === 'number' ){ // numeric validations
						if( !isD(obj.myvalue) ){
							s.errorMessages[obj.id] = 'Value must be numeric.';
							obj.myvalue = '';
						} else {
							myvalue = obj.myvalue;
							if( obj.required && myvalue === '' )
								s.errorMessages[obj.id] = '';
							else if( myvalue !== '' && !angular.isNumber(myvalue) )
								s.errorMessages[obj.id] = 'Value must be numeric.';
							else if( myvalue !== '' && ( minlen > myvalue || ( maxlen > 0 && myvalue > maxlen ) ) )
								s.errorMessages[obj.id] = 'The value must be numeric and between ' + minlen + ' and ' + maxlen + '.';
						}
					}
					else if( ftype === 'option' || ftype === 'select' ){ // option,select validations
						myvalue = angular.isDefined(obj.myvalue) && obj.myvalue !== null ? obj.myvalue.toString().trim() : '';
						if( obj.required && myvalue === '' ){
							s.errorMessages[obj.id] = '';
						} else if( myvalue !== '' ){
							angular.forEach( obj.fieldvalues, function( val, key){
								if( myvalue === val.optionval.toString().trim() )
									matched = true;
							});
							if( !matched )
								s.errorMessages[obj.id] = 'The option you have selected is invalid.';
						}
					}
					else if( ftype === 'checkbox' ){ // checkbox  validations
						minlen = obj.minval !== '' ? parseInt(obj.minval) : '';
						maxlen = obj.maxval !== '' ? parseInt(obj.maxval) : '';
						var checked = 0;
						angular.forEach( obj.fieldvalues, function( val, key){
							if(  val.ischecked )
								checked++;
						});
						if( obj.required && checked === 0 )
							s.errorMessages[obj.id] = '';
						else if( minlen !== '' && checked > 0 && checked < minlen )
							s.errorMessages[obj.id] = 'You must select at least ' + minlen + ' item' + (minlen > 1 ? 's.' : '.');
						else if( maxlen !== '' && checked > 0 && checked > maxlen )
							s.errorMessages[obj.id] = 'You must select no more than ' + maxlen + ' item' + (maxlen > 1 ? 's.' : '.');
					}

					if( obj.id in s.errorMessages )
						s.success = false;
				});
			}

		};

		/** standard form validations **/
		var validateForm = function(){
			var totalQty = 0;
			var hasEmptyRows = false;
			s.success = true;
			s.errorMessages = {};
			// this shouldn't happen, but verify that sign up information is avaialble
			if( parseInt(s.objForm.listid) === 0 || parseInt(s.objForm.owner) === 0 || s.objForm.urlid === '' ){
				s.errorMessages.signup = 'Invalid sign up. Please refresh your page or start the sign up process.';
				s.success = false;
			}

			if( !s.isrsvp && !s.objForm.siid.length ){
				s.errorMessages.items = 'Invalid sign up. You must select a slot.';
				s.success = false;
			}

			// validate name if not logged in
			if( !s.user.loggedin ){
				if( s.objForm.firstname === '' || elemLenCheck( 'firstname' ) > 50 ){
					s.errorMessages.firstname = elemLenCheck( 'firstname' ) > 50 ? s.standardErrors.firstname_length : '';
					s.success = false;
				}
				if( elemLenCheck( 'lastname' ) > 100 ){
					s.errorMessages.lastname = s.standardErrors.lastname_length;
					s.success = false;
				}
				if( s.emailRequired ){
					if( s.objForm.email === '' ) {
						s.errorMessages.email = '';
						s.success = false;
					}
					else if( !angular.isDefined(s.objForm.email) || !utility.validateEmail( s.objForm.email ) ){
						s.errorMessages.email = s.standardErrors.email_invalid;
						s.success = false;
					}
					else if( elemLenCheck( 'email' ) > 100 ){
						s.errorMessages.email = s.standardErrors.email_length;
						s.success = false;
					}

				}
				
				// test for google or yahoo groups email address
				if( typeof s.objForm.email !== 'undefined' && (s.objForm.email.search(/googlegroups.com/i) > -1 || s.objForm.email.search(/yahoogroups.com/i) > -1) ){
					s.errorMessages.email = s.standardErrors.email_disallowed;
					s.success = false;
				}

			}

			// validate alternate display name
			if( s.objForm.usealternatename ){
				if( s.objForm.displayfirstname === '' || elemLenCheck( 'displayfirstname' ) > 50 ){
					s.errorMessages.displayfirstname = elemLenCheck( 'displayfirstname' ) > 50 ? s.standardErrors.firstname_length : '';
					s.success = false;
				}
				if( elemLenCheck( 'displaylastname' ) > 100 ){
					s.errorMessages.displaylastname = s.standardErrors.lastname_length;
					s.success = false;
				}
			}

			// if signup is rsvp
			if( s.isrsvp ){
				var validRSVPs = ['y','n','m'];
				var adult = isD(s.objForm.rsvpadult) ? parseInt(s.objForm.rsvpadult) : 0;
				var children = isD(s.objForm.rsvpchildren) ? parseInt(s.objForm.rsvpchildren) : 0;
				if( validRSVPs.indexOf(s.objForm.rsvpresponse) < 0 ){
					s.errorMessages.rsvpresponse = '';
					s.success = false;
				}
				// validate adult count if children is not an option
				if( (s.objForm.rsvpresponse === 'y' || s.objForm.rsvpresponse === 'm' ) && (adult === 0 && children === 0) ){
					s.errorMessages.rsvpadults = '';
					s.success = false;
				}

				if( isD(s.objForm.rsvpitems) && angular.isArray(s.objForm.rsvpitems) ){
					angular.forEach( s.objForm.rsvpitems, function(obj,key){
						obj.qtyError = '';
						obj.slotError = '';
						obj.commentError = false;
						if( (obj.slotitemid === null || !isD(obj.slotitemid)) && !obj.deleted && ( obj.myqty > 0 || obj.mycomment.toString().trim().length) ){
							obj.slotError = 'You must select an item.';
							s.success = false;
						}
						if( obj.slotitemid > 0 && (!angular.isNumber(obj.myqty) || parseInt(obj.myqty) === 0) ){
							obj.qtyError = 'Invalid quantity.';
							s.success = false;
						}
						if( s.commentsRequired && obj.slotitemid > 0 && !obj.deleted && !obj.mycomment.toString().trim().length ){
							obj.commentError = true;
							s.success = false;
						}
					});
				}
			}

			if( !s.success )
				return;

			// basic quantity and comments check
			if( !s.isrsvp ){
				angular.forEach(s.items, function(obj,key){
					obj.commentError = false;
					obj.qtyError = false;
					if( !isD(obj.myqty) || obj.myqty === null ){
						obj.qtyError = true;
						s.success = false;
					}
					if( s.commentsRequired && !obj.mycomment.toString().trim().length ){
						obj.commentError = true;
						s.success = false;
					}

				});

			}

			if( !s.success )
				return;

			// comments or qty limit checks
			if( s.qtyLimitEnabled || s.hasPayItems ){
				if( s.isrsvp ){
					hasEmptyRows = false;
					// RSVP
					angular.forEach( s.objForm.rsvpitems, function(obj,key){
						obj.slotError = '';
						if( obj.slotitemid === 0 ){
							hasEmptyRows = true;
						}
						else {
							// quantity limit
							if( s.qtyLimitEnabled ){
								if( s.signupQtyLimit > 0 ){
									totalQty += parseInt(obj.myqty);
								}
								else if( s.itemQtyLimit > 0 && obj.qtyError === '' ){
									obj.qtyError = '';
									if( parseInt(obj.myqty) > s.itemQtyLimit ){
										obj.qtyError = "Quantity limit is set to " +  s.itemQtyLimit + ".";
										s.success = false;
									}
								}
							}
						}
					});

					// remove any empty rows the user added
					if( hasEmptyRows ){
						var i = s.objForm.rsvpitems.length - 1;
						for( i; i >= 0; i-- ){
							if( s.objForm.rsvpitems[i].slotitemid === 0 &&  s.objForm.rsvpitems[i].item === '' )
								s.objForm.rsvpitems.splice(i,1);
						}
						if( !s.objForm.rsvpitems.length )
							s.addMoreRSVPItem();
					}

				}
				else {
					// Standard
					angular.forEach(s.items, function(obj,key){
						var _thisminprice = 0;

						// quantity limit
						if( s.qtyLimitEnabled ){
							if( s.signupQtyLimit > 0 ){
								totalQty += parseInt(obj.myqty);
							}
							else if( s.itemQtyLimit > 0 ){
								obj.qtyError = false;
								if( parseInt(obj.myqty) > s.itemQtyLimit ){
									obj.qtyError = true;
									s.errorMessages['itemqtylimit_' + obj.id] = "Quantity limit is set to " +  s.itemQtyLimit + ".";
									s.success = false;
								}
							}
						}

						// minimum amount
						obj.priceError = false;
						if( s.arrpaytypes.indexOf( obj.paymenttype ) >= 0  ){
							_thisminprice = isD(obj.minimumamount) ? toFloat(obj.minimumamount).toFixed(2) : 0.00;
							if( toFloat(obj.price) < _thisminprice ){
								s.errorMessages['priceminimum_' + obj.id] = 'A minimum amount of ' + s.currency_symbol + _thisminprice + ' is required.';
								obj.priceError = true;
								s.success = false;
							}
							// verify that when payment type use choices, the user must select one option.
							if( !obj.priceError && obj.paymenttype.toString().toLowerCase() === 'options' ){
								if( !angular.isObject(obj.paymentOptionSelected) || !isD(obj.paymentOptionSelected.value) ){
									s.errorMessages['priceminimum_' + obj.id] = 'You must select one of the options.';
									obj.priceError = true;
									s.success = false;
								}
							}
						}
					});

				} // end standard

				if( s.qtyLimitEnabled && s.signupQtyLimit > 0 && totalQty > s.signupQtyLimit ){
					s.errorMessages.signupqtylimit = true;
					s.success = false;
					util.showMagnificAlert('You have exceeded the quantity limit set up by the sign up creator. You are not allowed to sign up for more than ' + s.signupQtyLimit + ' ' + (s.signupQtyLimit == 1 ? 'item' : 'total items') + ' on this sign up.');
				}
			}
			else {
				if( s.isrsvp ){
					hasEmptyRows = false;
					// RSVP
					angular.forEach( s.objForm.rsvpitems, function(obj,key){
						if( obj.slotitemid === 0 ){
							hasEmptyRows = true;
						}
						else {
							obj.commentError = false;
							if( (obj.slotitemid === null || !isD(obj.slotitemid)) && !obj.deleted && ( obj.myqty > 0 || obj.mycomment.toString().trim().length) ){
								obj.slotError = 'You must select an item.';
								s.errorMessages.slotitemid = 'You must select an item.';
								s.success = false;
							}
						}
					});

					// remove any empty rows the user added
					if( hasEmptyRows ){
						var i = s.objForm.rsvpitems.length - 1;
						for( i; i >= 0; i-- ){
							if( s.objForm.rsvpitems[i].slotitemid === 0 &&  s.objForm.rsvpitems[i].item === '' )
								s.objForm.rsvpitems.splice(i,1);
						}
						if( !s.objForm.rsvpitems.length )
							s.addMoreRSVPItem();
					}

				}

			} // end checks

		};

		var elemLenCheck = function( elem ){
			return isD( s.objForm[elem] ) ? s.objForm[elem].toString().trim().length : 0;
		};

		var resultCheck = function( response ){
			var result = util.lowerCaseKeys( response );
			try {
				return (angular.isDefined(result.success) && result.success && angular.isDefined(result.data));
			} catch( e ){
				return false;
			}
		};

		var errorHandler = function( response ){
			var errMessage = svc.resultErrorHandler( response );
			util.showMagnificAlert(errMessage);
		};

		/* helper method to calculate total quantity selected by itemid */
		var getTotalQuantities = function( itemsArr ){
			// array of aggregate quantities selected by item to be returned
			var totalQtyByItem = [];
			// iterate items obj and create array of itemids
			itemsArr.forEach( function(obj){
				// get current row
				var row = {
					"itemid": obj.itemid,
					"myqty": obj.myqty
				};
				// if array empty add first item
				if( totalQtyByItem.length === 0){
					totalQtyByItem.push(row);
				}
				else{
					// scan array to see if itemid already exists
					var itemFound = false;
					totalQtyByItem.forEach( function(itm){
						// if itemid is found, add to total
						if(itm.itemid == obj.itemid){
							itm.myqty += obj.myqty;
							itemFound = true;
						}
					});
					// if itemid isn't found, insert row for it
					if( !itemFound ){
						totalQtyByItem.push(row);
					}
				}
			});

			// return array of quantites by itemid
			return totalQtyByItem;

		};

		s.editSignup = function(memberid,id,urlid,listformat,itemmemberid,slotitemid){
            var attrsObj = {};
            attrsObj.imid = itemmemberid;
            attrsObj.mid = memberid;
            attrsObj.siid = slotitemid;
            attrsObj.urlid = urlid;
            signupPageService.setAttrs(attrsObj);

			$route.reload();
		};

		var refreshSelectPicker = function(){
			$timeout(function() {
				angular.element('.selectpicker').selectpicker('refresh');
			}, 200);
		};

		// this picker refresh is specific to silly quantity selection
		s.refreshPicker = function( strclass ){
			var classname = typeof strclass !== 'undefined' ? strclass : 'qtyselection';
			$timeout(function(){
				$('.selectpicker.' + classname ).selectpicker('refresh');
			},50);
		};

	}])
	.controller('multicalendarController',['$scope', '$modalInstance','items','icsCal','$sce', function( l, modal, items, cal, sce ){

		l.items = items;
		l.ical = cal;
		l.locationexist = false;
		angular.forEach( l.items, function(obj,key){
			obj.itemname = sce.trustAsHtml( obj.item.toString() );
			if( obj.location !== '' )
				locationexist = true;
		});
		l.close = function(){
			modal.dismiss();
		};

	}])
	.controller('signUpFormCompleteController',
				['$scope','SUGUtilities','$sce','signUpFormService','$uibModal','$window','$filter','$location','adService','$rootScope',
				function(s,util,sce,svc,modal,win,filter,location,adService,$rootScope){

		/** this controller is only triggered when there is a paypal payment that requires redirect and comes back to the thank you page
				For the thank you page look at the showThankYou() function **/
		util.showLoading( 'processing' );
		s.initialized = false;
		s.signupLoaded = false;
		s.h = new Date().getTime();
		s.user = {};
		s.user.loggedin = false;
		s.signup = {};
		s.theme = {};
		s.asyncSuccess = true;
		s.success = true;
		s.signupTitle = '';
		s.signupDesc = '';
		s.datedisplay = "";
		s.dateformat = "";
		s.shortZone = "";
		s.editLocked = false;
		s.nodatesignup = false;
		s.socialshare = false;
		s.isrsvp = false;
		s.showsegments = true;
		s.thankYouTemplate = '/view/templates/signups/form/thankyou.html';
		s.isProcessing = false;
		s.urlid = utility.getUrlParamValue('urlid');
		s.sl = utility.getUrlParamValue('sl');
		s.checkoutid = angular.isDefined(utility.getUrlParamValue('checkout_id')) ? utility.getUrlParamValue('checkout_id') : '';
		s.wp = angular.isDefined(utility.getUrlParamValue('wp')) ? utility.getUrlParamValue('wp') : false;
		s.myitems = [];
		s.showreturntosulink = false;
		s.winorigin = angular.isDefined( win.location.origin ) ? win.location.origin : win.location.protocol + '//' + win.location.host;
		s.hAdWidth = 0;
		s.errormessage = "Oops! Something went terribly wrong. We can't seem to find the sign up information you've requested. If this error persists, please <a href='/help'>contact support</a>.";
		s.usenewaddirective = false;
		s.adconfig = {
			network  : '',
			platform : 'desktop',
			category : 'signups',
			section  : 'confirmation',
			type	 : '',
			position : ''
		};

		s.labels = {
			"backtosignup" : "Back to Sign Up",
			"addtocalendar" : "Add to Calendar",
			"editmysignup" : "Edit My Sign Up",
			"editmyrsvp" : "Edit My RSVP",
			"socialshare" : "Share with Friends",
			"returntosignup" : "Return to Sign Up",
			"accountregistration" : sce.trustAsHtml('One more thing! Want to make it easier to sign up or edit your items in the future?<br /><span class="hyperlink" data-ng-click="register()">Create a free SignUpGenius account</span>')
		};

		if( s.wp && !s.checkoutid.toString().length ){
			s.errormessage = 'The checkout process has either expired or been cancelled. If this error persists, please <a href="/help">contact support</a>.';
			s.initialized = true;
			win.scrollTo( 0, 0 );
		}
		else {
			/** requests to get all the sign up information **/
			svc.getUserInfo()
				.then( function( member ){
					var r = util.lowerCaseKeys( member );
					if( !resultCheck( r.data ) ){
						s.asyncSuccess = false;
						errorHandler( r.data );
					}
					else {
						s.user = r.data.data;
						s.user.loggedin = ( angular.isDefined( s.user.memberid ) && parseInt(s.user.memberid) > 0 );

						var d = {};
							d.fuse = 's.ProcessSignupComplete';
						return globalService.checkNewAdDirective(d);
					}
				})
				.then( function( newad ) {
					var r = util.lowerCaseKeys( newad );
					if( resultCheck( r.data ) ){
						s.usenewaddirective = r.data.data;
					}

					// get sign up details
					var d = {};
						d.urlid = s.urlid;
						d.sl = s.sl;
						d.wp = s.wp === "" ? false : s.wp;
						if( s.checkoutid.toString().length > 0 )
							d.checkoutid = s.checkoutid;
					return svc.getCompletedSignUpDetail(d);
				})
				.then(function( signup ){
					if( s.asyncSuccess ){
						var r = util.lowerCaseKeys( signup );
						if( !resultCheck( r.data ) ){
							s.asyncSuccess = false;
							errorHandler( r.data );
						}
						else {
							var data = r.data.data;
							if( !angular.isDefined(data.signup.id) || parseInt(data.signup.id) === 0 ){
								s.asyncSuccess = false;
								util.showMagnificAlert('The sign up is no longer available.');
							}
							else {
								// ad directive
								if( s.usenewaddirective ){
									s.adconfig.themeid = s.signup.themeid;
									var adnetworks = typeof $rootScope.adnetworkdatafile !== 'undefined' && typeof $rootScope.adnetworkdatafile.networks !== 'undefined' ? $rootScope.adnetworkdatafile.networks : {};
									s.adconfig.network = adService.getAdNetwork(s.adconfig,adnetworks);
									// set header ad code
									adService.setHeaderAdCode( s.adconfig );
								}

								// ROKT
								if(data.extendedattributes) {
									// Hide Banner Ads
									// SUG-6585: Turning this off for now - per the requirements, it needs to be so that it can be renabled if needed
									/*
									if (win.sug_data.page_experience && win.sug_data.page_experience.indexOf("split_segment_off_") > -1){
										// Need to add page experioence to extendedattributes here so it passes to iniToktSnippit call
										data.extendedattributes.page_experience = win.sug_data.page_experience;
										s.hideBannerAdsForRokt = true;
									}
									*/
									// Display Rokt Ad
									if (data.extendedattributes.email){
										adService.initRoktSnippet(data.extendedattributes);
										adService.initAdsPostXSnippet(data.extendedattributes);
										s.hideBannerAdsForRokt = true; // set this to true moving forward
									}
								}

								setFormElements( data );
								s.signupLoaded = true;
								var theme = {};
									theme.themeID = s.signup.themeid;
									theme.listid = s.signup.id;
									theme.returnType = 'class';
								return signupPageService.getSignupTheme( theme );

							}
						}
					}
				})
				.then( function( theme ){
					if( s.asyncSuccess ){
						var r = util.lowerCaseKeys( theme );
						if( !resultCheck( r.data ) ){
							s.asyncSuccess = false;
							errorHandler( r.data );
						}
						else {
							/** build dynamic classes **/
							s.theme = r.data.data;
							s.createSignUpStyle();
						}
					}
				})
				.then( function(){
					s.initialized = true;
					win.scrollTo( 0, 0 );
				});
			}

			s.backToSignUp = function(){
				var urlId = angular.isDefined( s.urlid ) && s.urlid !== '' ? s.urlid : '';
				if( urlId === '' )
					urlId = angular.isDefined( s.attrs) && angular.isDefined( s.attrs.urlid ) && s.attrs.urlid !== '' ? s.attrs.urlid : '';
				if( urlId !== '' )
					win.location.href = s.winorigin + '/go/' + urlId;
				else
					win.location.href = s.winorigin + '/index.cfm';
			};

			s.register = function(){
				var loginWindow = modal.open({
					templateUrl : '/view/templates/main/login.html',
					controller : 'authenticationController',
					resolve : {
						loginRequired : function(){
							return false;
						},
						loginMessage: function(){
							return '';
						},
						register: function(){
							return true;
						},
                        registerDisabled: function () {
                            return false;
                        }
					}
				});

				loginWindow.result.then(
					function( response ){
						var r = response;
						if( isD(r.status) && r.status === 'loggedin' && isD(r.data) && isD( r.data.memberid ) && parseInt(r.data.memberid) > 0 ){
							s.user = r.data;
							if (s.useSinglePageApplication) {
								// Updated cached member info
								signupPageService.setMemberInfo(s.user);
								svc.cachedMemberinfo = s.user;
							}
							s.user.loggedin = true;
							// update upper main navivation menus
							updateMenu();
						}
					});
			};

			/** method to create dynamic sign up styles **/
			s.createSignUpStyle = function(){
				// this is where our dynamic style container will be
				var styleContainer = angular.element( document.querySelector( '#styleContainer' ) );
				// create a style tag containing all the classes
				var dStyles = angular.element( '<style type="text/css">' + s.theme + '</style>' );
				// append the style to the container
				styleContainer.append( dStyles );
			};

			s.goBackTo = function(){
				if( s.showreturntosulink ){
					var url = s.backtosignupLink.indexOf('http') == -1 ? "http://" + s.backtosignupLink : s.backtosignupLink;

					var alertWindow = modal.open({
						templateUrl : '/view/templates/signups/form/backtowebsiteconfirm.html',
						controller : 'backToWebsiteController',
						resolve : {
							redirect : function(){
								return url;
							}
						}
					});

					alertWindow.result.then(
						function(){
							win.location.href = url;
						});
				}
				else {
					if (s.useSinglePageApplication) {
						// When using the SPA, return user to base route
						location.path("/");
					} else {
						win.location.href = s.winorigin + s.backtosignupLink;
					}
				}

				// set/recycle ads
				if( s.showsegments && typeof deployads !== 'undefined' ){
					setTimeout( function(){
						deployads.push();
					}, 500);
				}

			};

			/** helper method to setup sign up form elements **/
			var setFormElements = function( data ){
				// setup
				s.signup = data.signup;
				s.items = data.items;
				s.backtosignupLink = "/go/" + s.signup.urlid;
				s.calLinks = angular.isDefined(data.icals) ? data.icals : {};
				s.memberinfo = angular.isDefined(data.memberinfo) ? data.memberinfo : {memberid:0,displayfirstname:'',displaylastname:'',fullmember:false};
				s.confirmationsent = s.memberinfo.memberid > 0;
				s.isfullmember = angular.isDefined(s.memberinfo.fullmember) ? s.memberinfo.fullmember : false;
				s.signupTitle = sce.trustAsHtml(s.signup.title.toString());
				s.signupDesc = sce.trustAsHtml(s.signup.description.toString());
				s.datedisplay = s.signup.shortdformat;
				s.dateformat = s.signup.shortdformat.toString().replace("mm","MM");
				s.shortZone = s.signup.tzshort;
				s.nodatesignup = (parseInt(s.signup.nodate) === 1);
				s.isrsvp = (parseInt( s.signup.usersvp ) === 1);
				s.socialshare = (parseInt(s.signup.socialshare) === 1);
				s.showsegments = s.signup.showsegments;
				s.closeLock = (s.signup.closelock > 0);
				s.modifyLock = parseInt(s.signup.modifylockdays);
				s.listid = s.signup.id;
				s.signupowner = s.signup.owner;
				s.signupcontact = s.signup.contactname;
				s.linktowebsite = '';
				s.linktowebsitebtn = '';
				if( s.signup.linktowebsite.toString().length ){
					var ltw = s.signup.linktowebsite.split('|');
					if( ltw.length === 2 ){
						s.linktowebsite = ltw[1];
						s.linktowebsitebtn = ltw[0];
						s.backtosignupLink = ltw[1];
						s.labels.backtosignup = ltw[0];
						s.showreturntosulink = true;
						s.returntosulink = "/go/" + s.signup.urlid;
					}
				}

				// if there is a retargeting script
				if( angular.isDefined(data.retargetingscripts) && data.retargetingscripts !== '' ){
					document.getElementById("retargeting").innerHTML = '';
					document.getElementById("retargeting").innerHTML = data.retargetingscripts;
				}


				/** do some randomize ad AB testing on the thank you page **/
				if( s.showsegments ){
					s.hAdWidth = 190;
					s.containerWidth = win.innerWidth;
					if( s.containerWidth > 1199 )
						s.hAdWidth = 330;

					// var r = Math.floor((Math.random() * 100) + 1);
					// if( r % 2 === 0 )
					s.thankYouTemplate = '/view/templates/signups/form/altthankyou.html';
				}

				// if sign up is RSVP
				if( s.isrsvp ){
					// no payments on RSVP just yet - any rsvp related variables can go here

				}
				else {
					// standard sign ups
					s.name = s.memberinfo.displayfirstname;
					s.memberid = s.memberinfo.memberid;
					s.showCalendar = (s.memberinfo.memberid > 0 && !s.nodatesignup);
					s.slotids = '';

					var dtstarttime = '';
					var dtendtime = '';
					var gc = angular.isDefined(s.calLinks.google) ? s.calLinks.google : {};
					var temp = {};
					s.slotids = [];
					angular.forEach(s.items, function(obj,key){
						s.slotids.push( obj.slotid );
					});

					s.slotids = s.slotids.toString();
					s.myitems = [];
					angular.forEach( s.items, function(obj,key){
						dtstarttime = '';
						dtendtime = '';
						temp = {};
						temp.item = obj.item;
						temp.itemhelp = obj.itemcomment;
						temp.myqty = obj.myqty;
						temp.mycomment = obj.mycomment;
						temp.slotid = obj.slotid;
						temp.slotitemid = obj.slotitemid;
						temp.itemmemberid = obj.itemmemberid;
						temp.location = obj.location;
						temp.slotdatestring = '';
						if(obj.starttime !== ''){
							try {
								dtstarttime = new Date( obj.starttime );
								dtstarttime = Date.parse( dtstarttime );
								temp.slotdatestring = filter('date')(dtstarttime, 'EEE') + '., ' + filter('date')(dtstarttime, s.dateformat );
								if( obj.usetime === 1 )
									temp.slotdatestring += ' ' + (filter('date')(dtstarttime, 'h:mma' )).toLowerCase();
							} catch( e ){}
						}
						if( obj.usetime === 1 && obj.dtendtime !== '' && obj.dtendtime !== obj.dtstarttime ){
							try {
								dtendtime = new Date( obj.endtime );
								dtendtime = Date.parse( dtendtime );
								temp.slotdatestring += ' - ' + (filter('date')(dtendtime, 'h:mma' )).toLowerCase();
							} catch( e ){}
						}
						if( temp.slotdatestring !== '' && obj.usetime === 1 )
							temp.slotdatestring += ' ' + s.shortZone;
						// trim it just in case
						temp.slotdatestring =  temp.slotdatestring.trim();
						temp.callink = obj.slotid in gc ? gc[obj.slotid] : '';
						s.myitems.push( temp );
					});

				}

			};

			var resultCheck = function( response ){
				var result = util.lowerCaseKeys( response );
				try {
					return (angular.isDefined(result.success) && result.success && angular.isDefined(result.data));
				} catch( e ){
					return false;
				}
			};

			var errorHandler = function( response ){
				var errMessage = svc.resultErrorHandler( response );
				util.showMagnificAlert(errMessage);
			};

			/** helper method for updating top navigation menu **/
			var updateMenu = function(){
				svc.getMainNavigation()
					.then( function(response){
						var r = util.lowerCaseKeys( response );
						if( !resultCheck( r.data ) ){
							errorHandler( r.data );
						}
						else {
							var menu = angular.element( document.querySelector( '#main-nav' ) );
								menu.empty(); // remove existing menu
								menu.append( r.data.data ); // append the new menu
						}
					});
			};

			/** method for social media sharing **/
			s.share = function( media ){
				var signupurl = angular.isDefined(s.signup.fullurl) && s.signup.fullurl !== '' ? s.signup.fullurl : encodeURIComponent(s.winorigin + "/go/" + s.attrs.urlid);
				var signupimage = s.signup.signupimage !== '' ? encodeURIComponent(s.signup.signupimage) : encodeURIComponent(s.winorigin + "/images/theme/" + s.signup.themeid + "-large.jpg");
				var mediaurl = '';
				var winsize = '';
				var py = 0;
				var px = 0;
				var tweettext = encodeURIComponent("I just signed up on the " + s.signup.title.toString().trim() + " page - ");
				if( media === 'fb' ){
					winsize = "width=640,height=400";
					py = win.top.outerHeight / 2 + win.top.screenY - ( 400 / 2);
					px = win.top.outerWidth / 2 + win.top.screenX - ( 640 / 2);
					mediaurl = "http://www.facebook.com/sharer/sharer.php?u=" + signupurl + "&src=sp";
				}
				else if( media === 'pinterest' ){
					winsize = "width=740,height=700";
					py = win.top.outerHeight / 2 + win.top.screenY - ( 700 / 2);
					px = win.top.outerWidth / 2 + win.top.screenX - ( 740 / 2);
					mediaurl = "http://pinterest.com/pin/create/button/?url=" + signupurl + "&media=" + signupimage + "&description=" + tweettext + '%20' + signupurl;
				}
				else if( media === 'twitter' ){
					winsize = "width=640,height=320";
					py = win.top.outerHeight / 2 + win.top.screenY - ( 320 / 2);
					px = win.top.outerWidth / 2 + win.top.screenX - ( 640 / 2);
					mediaurl = "https://twitter.com/share?text=" + tweettext + "&url=" + signupurl;
				}

				// open the window
				winsize += ",top=" + py + ",left=" + px;
				win.open(mediaurl,'_blank',winsize);
			};


			/** method to get ics **/
			s.getICS = function( cal ){
				var icalLink = '';
				if( s.isrsvp ){
					icalLink = cal in s.calLinks ? s.calLinks[cal] : '';
				}
				else {
					if( cal === 'ical' ){
						icalLink = cal in s.calLinks ? s.calLinks[cal] : '';
					}
					else {
						if( s.myitems.length === 1 ){
							icalLink = s.myitems[0].callink || '';
						}
						else {
							// we will need to do a modal window to show the list of calendars
							var calendarWindow = modal.open({
								templateUrl : '/view/templates/signups/form/multicalendardownload.html',
								controller : 'multicalendarController',
								resolve : {
									items : function(){
										return s.myitems;
									},
									icsCal : function(){
										return angular.isDefined(s.calLinks.ical) ? s.calLinks.ical : '';
									}
								}
							});

							calendarWindow.result.then(
								function( response ){
									// do nothing
								});
						} // end
					}
				}
				if( icalLink.length )
					win.open(icalLink);
			};

	}])
	.controller('alertController', ['$scope', '$modalInstance','message','messagetitle', function( $scope, $modalInstance, message, messagetitle ){
		$scope.message = message;
		$scope.messagetitle = messagetitle;
		$scope.close = function(){
			$modalInstance.dismiss();
		};
	}])
	.controller('backToWebsiteController', ['$scope', '$modalInstance','redirect','$timeout','$window',
		function( $scope, $modalInstance, redirect, timeout, win ){
		$scope.url = redirect;
		$scope.seconds = 11;

		$scope.cancel = function(){
			$modalInstance.dismiss();
		};

		$scope.close = function(){
			$modalInstance.close();
		};

		$scope.countDown = function() {
			if( $scope.seconds === 0 ){
				$scope.close();
				// return false;
			} else {
				$scope.seconds--;
				timeout( function(){
					$scope.countDown();
				}, 1000);
			}
		};

		$scope.countDown();
	}])
	// New version of wePay Modal controller for handling 3rd party cookie fix
	.controller('wePayModalController', ['$scope', '$modalInstance', '$window', '$sce', 'SUGUtilities', 'payload', 'mainScope',
			function ($scope, $modalInstance, $window, $sce, SUGUtilities, payload, mainScope ) {

		/* WePay Payment Modal Controller */
		SUGUtilities.showLoading( 'iFrameContainer' );

		$window.credit_card_id = 0;
		$window.frm = {};
		$window.frm = payload;
		$window.wepayclientid = mainScope.wepayclientid;
		$window.wepayendpoint = mainScope.wepayendpoint;
		$window.environment = mainScope.environment;
		$window.countries = mainScope.countries.data;

		var iframeSrc = $window.environment + '/view/tools/wepaycheckoutiframe.html';
		$scope.iFrameSrc = $sce.trustAsResourceUrl(iframeSrc);

		$scope.loading = true;
		$scope.complete = false;
		$scope.response = {success: false};


		var checkoutOrigin = $window.environment;
		// Create IE + others compatible event handler
		var eventAddMethod = $window.addEventListener ? "addEventListener" : "attachEvent";
		var eventRemoveMethod = $window.addEventListener ? "removeEventListener" : "detachEvent";
		var messageEvent = eventAddMethod == "attachEvent" ? "onmessage" : "message";
		var eventerAdd = $window[eventAddMethod];
		var eventerRemove = $window[eventRemoveMethod];

		// Handler function for event listener
		var handleMessageEvent = function(e){
			// check the origin of the message to ensure its from WePay
			if(e.origin === checkoutOrigin && e.data){
				try{
					var stcData = e.data;	//JSON.parse(e.data);

					// Check for credit_card_id from payment iframe
					if(typeof stcData.credit_card_id != 'undefined'){
						payload.payment_method.credit_card.id = stcData.credit_card_id;
						$scope.complete = true;
						$scope.response.success = true;
						mainScope.completeWePayPayment(payload, $modalInstance);
					}

				}catch(err){
					// silent error
				}
			}
		};

		// Listen for the postMessage from WePay indicating the checkout was complete
		eventerAdd(messageEvent,handleMessageEvent);

		/**
		 * Fired when the close button (x) is clicked. Issues a warning if the payment is not complete.
		 * */
		$scope.dismiss = function(){
			if( !$scope.complete ){
				SUGUtilities.showConfirmationModal({
					txtConfirmationTitle: "Incomplete Checkout",
					txtConfirmationMessage: "You have not completed the checkout process. Are you sure you want to cancel?",
					lblYesButton: "Yes"
				},
				function(){
					$modalInstance.dismiss($scope.response);
					// Remove event listener when closing modal to prevent being processed multiple times if the modal is relaunched
					eventerRemove(messageEvent, handleMessageEvent);
				});
			}
			else {
				$modalInstance.dismiss($scope.response);
			}
		};

		// fired when the modal closes
		$scope.close = function(){
			$modalInstance.close($scope.response);
		};

		// fired on the iframe onload event
		$scope.loaded = function(){
			$scope.loading = false;
		};

	}])


	// LumaPay Modal controller
	.controller('lumaPayModalController', ['$scope', '$modalInstance', '$window', '$sce', 'SUGUtilities', 'payload', 'mainScope', '$timeout', 'signUpFormService','errorService',
	function ($scope, $modalInstance, $window, $sce, SUGUtilities, payload, mainScope, $timeout, svc, errorService ) {
		$scope.es = errorService.newInstance();
		$scope.errorStrings = {
			errorsTitle: '',
			errorsPleaseCorrect: 'Please correct the issues indicated below.'
		};
		/* LumaPay Payment Modal Controller */
		SUGUtilities.showLoading( 'LumapayCheckout' );
		// default to on while loading

		$scope.processing = {
			isProcessing: true,
			progress: '' // see "Spinner w/ Progress (Loading/Processing Indicator)" documentation for how this can be used
		};

		$scope.submitted = false;
		$scope.complete = false;
		$scope.response = {success: false};
		$scope.payload = payload;

		$scope.buttonText = payload.grossamount < 1 ? 'Pay $0'+payload.grossamount.toFixed(2) + payload.currency_suffix : 'Pay $'+payload.grossamount.toFixed(2) + payload.currency_suffix;

		// Broadcast listener - useful so can be called from separate controller/service/etc
		$scope.$on('isProcessing', function (event, isProcessing) {
			$scope.processing.isProcessing = isProcessing;
			if (isProcessing) {
				SUGUtilities.showLoading('processing');
			}
		});

		// Create a Stripe client.
		var stripe = Stripe(payload.stripeapikey,
			{ stripeAccount: payload.stripeaccount },
			{ apiVersion: payload.stripeapiversion });

		// Fetches a payment intent and captures the client secret
		var init = function () {
			// always ensure that recalling init will reinitiate the spinner too
			SUGUtilities.broadCast('isProcessing', true);

			var options = {
				clientSecret: payload.clientsecret,
				stripeAccount: payload.stripeaccount,
				// Fully customizable with appearance API.
				appearance: {
					theme: 'stripe'
				},
			};
			$scope.elements = stripe.elements(options);
			var paymentElement = $scope.elements.create("payment");
			// Wrap mount call in timeout, otherwise the code throws an error about not being able to fin the payment-elements element in the DOM
			$timeout(function(){
				paymentElement.mount("#payment-element");
			},500);

			// when done initializing, turn processing off
			SUGUtilities.broadCast('isProcessing', false);
		};
		init();

		$scope.handleSubmit = function() {
			//SUGUtilities.broadCast('isProcessing', true);
			$scope.es.clearErrors();  // clear all errors
			if ($scope.payload.nameOnCard) {
				$scope.submitted = true;

				stripe.confirmPayment({
					elements: $scope.elements,
					confirmParams: {
						// return_url is included but will not be used since we are not using any payment types that require redirect.
						return_url: payload.returnurl,
					},
					// this prevents redirect for payment types that do not require redirect
					redirect: "if_required"
				}).then(function(result) {


// TO DO: Add catch to handle payment types that require redirect to future proof the code
					if (result.error) {
						$timeout(function(){
							SUGUtilities.broadCast('isProcessing', false);
							$scope.submitted = false;
							// Inform the customer that there was an error.

							// This point will only be reached if there is an immediate error when confirming the payment. Otherwise, your customer will be redirected to
							// your `return_url`. For some payment methods like iDEAL, your customer will be redirected to an intermediate site first to authorize the payment, then
							// redirected to the `return_url`.
							$scope.es.setError('error-top-level',result.error.message);
						},1000);

					} else {
						$scope.response.success = true;
						$scope.response.paymentIntent = result.paymentIntent;
						mainScope.completeLumaPayPayment(payload, $modalInstance);
					}
			 	}).catch(function(err){					
					SUGUtilities.broadCast('isProcessing', false);
					$scope.submitted = false;
					// Inform the customer that there was an error.
					$scope.es.setError('error-top-level','There was an error processing your payment.');
					console.err(err);					
				});
			} else {
				$scope.submitted = false;
				SUGUtilities.broadCast('isProcessing', false);
			}
		};

		/**
		 * Fired when the close button (x) is clicked. Issues a warning if the payment is not complete.
		 * */
		$scope.dismiss = function(){
			if( !$scope.complete ){
				SUGUtilities.showConfirmationModal({
					txtConfirmationTitle: "Incomplete Checkout",
					txtConfirmationMessage: "You have not completed the checkout process. Are you sure you want to cancel?",
					lblYesButton: "Yes"
				},
				function(){
					$modalInstance.dismiss($scope.response);
				});
			}
			else {
				$modalInstance.dismiss($scope.response);
			}
		};

		// fired when the modal closes
		$scope.close = function(){
			$modalInstance.close($scope.response);
		};

	}]);
})();
